// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:36:54.081Z
// Property: Domain at Founders Parc (ID: 5684048244506624)
// Collections: 21 amenities, 13 floorplans (live), 31 photos, 82 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live), 18 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5684048244506624",
  "property_external_id": "4792503",
  "property_zillow_url": "https://www.zillow.com/b/880-w-euless-blvd-euless-tx-BjY5sJ/",
  "property_apartments_url": "https://www.apartments.com/domain-at-founders-parc-euless-tx/p2kcvks",
  "property_google_business_url": "https://www.google.com/maps/place/Domain+at+Founders+Parc/@32.8314385,-97.0964872,15z/data=!4m2!3m1!1s0x0:0x34085c13e41f574a?sa=X&ved=2ahUKEwisieTu9OH2AhXcmWoFHaCxBYUQ_BJ6BAgmEAU",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443965266",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "domain-at-founders-parc",
  "property_name": "Domain at Founders Parc",
  "property_website_url": "https://www.domainatfoundersparc.com/",
  "property_domain": "https://www.domainatfoundersparc.com/",
  "property_address": "880 W Euless Blvd",
  "property_full_address": "880 W Euless Blvd, Euless, TX 76040",
  "property_address_1": "880 W Euless Blvd",
  "property_address_2": null,
  "property_address_city": "Euless",
  "property_address_state": "TX",
  "property_address_zip_full": "76040-4420",
  "property_address_zip": "76040",
  "property_address_country": "US",
  "property_address_county": "Tarrant County",
  "property_neighborhood_address": "Hurst/Euless/Bedford",
  "property_address_latitude": "32.8308783",
  "property_address_longitude": "-97.0965131",
  "property_email": "domain@alapts.com",
  "property_phone": "(817) 898-5072",
  "property_call_tracking_phone": "817-572-8453",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Modern apartment living in the heart of Euless.</strong> Explore renovated one-, two-, and three-bedroom homes with stainless-steel appliances, wood-style flooring, in-home laundry, and resort-style spaces—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Domain at Founders Parc in person.</p>",
  "property_long_description": "<p><strong>Modern apartment living in the heart of Euless.</strong> At Domain at Founders Parc, you’re tucked into the Hurst/Euless/Bedford area with the polish of a recently renovated community and the everyday ease of a mixed-use setting. Choose from one-, two-, and three-bedroom <a href=\"/floor-plans\">apartment layouts</a> with stainless-steel appliances, wood-style flooring, in-home washer and dryer, large closets, and select kitchen islands, wine racks, garden tubs, and tile backsplashes.</p><p>Outside your door, <a href=\"/amenities\">resort-style amenities</a> make home feel like a destination: a pool with cabanas and water feature, fitness studio with yoga and spin room, cyber lounge, coffee bar, conference rooms, fire pit, outdoor kitchen, dog park, and dog wash. When you’re ready to explore, you’re near Grapevine, DFW Airport, Airport Freeway, Texas Star Golf Course, Parks at Texas Star, and Euless shopping and dining, with Target, ALDI, Whole Foods, and Glade Parks within easy reach. See more nearby favorites on the <a href=\"/neighborhood\">neighborhood guide</a>.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019d02f0-f79c-75eb-88a6-3d323ecaa267.webp",
  "property_featured_image_media": {
    "alt_text": "Modern apartment building with a resort-style pool and lounge chairs.",
    "public_id": "019d02f0-f79c-75eb-88a6-3d323ecaa267",
    "storage_key": "property/5684048244506624/019d02f0-f79c-75eb-88a6-3d323ecaa267.webp",
    "width": 1240,
    "height": 826
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "285",
  "property_year_built": "2020",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.33333333333333",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee: $75\nAdministrative Fee: $150\nApplication Approval Fee: Starting at $300",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8701112.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://domainatfoundersparc.loftliving.com/login",
  "property_apply_now_url": "https://8701112.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e4d76-1419-76a1-8909-4044971731a4.webp",
  "property_primary_logo_media": {
    "alt_text": "Domain at Founders Parc logo",
    "public_id": "019e4d76-1419-76a1-8909-4044971731a4",
    "storage_key": "property/5684048244506624/019e4d76-1419-76a1-8909-4044971731a4.webp",
    "width": 3072,
    "height": 1103
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e4d76-1b70-71e9-a815-85d5dd2cc640.webp",
  "property_secondary_logo_media": {
    "alt_text": "Domain at Founders Park logo",
    "public_id": "019e4d76-1b70-71e9-a815-85d5dd2cc640",
    "storage_key": "property/5684048244506624/019e4d76-1b70-71e9-a815-85d5dd2cc640.webp",
    "width": 3072,
    "height": 1955
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e4d76-15cc-7189-96ba-5acde6d16b60.webp",
  "property_icon_media": {
    "alt_text": "The logo of The Donaldson Group.",
    "public_id": "019e4d76-15cc-7189-96ba-5acde6d16b60",
    "storage_key": "property/5684048244506624/019e4d76-15cc-7189-96ba-5acde6d16b60.webp",
    "width": 3072,
    "height": 3072
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e4d76-15cc-7189-96ba-5acde6d16b60.webp",
  "property_fav_icon_media": {
    "alt_text": "The logo of The Donaldson Group.",
    "public_id": "019e4d76-15cc-7189-96ba-5acde6d16b60",
    "storage_key": "property/5684048244506624/019e4d76-15cc-7189-96ba-5acde6d16b60.webp",
    "width": 3072,
    "height": 3072
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e4d76-22f1-7480-91b3-2a03fdc24f18.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Domain at Founders Park logo",
    "public_id": "019e4d76-22f1-7480-91b3-2a03fdc24f18",
    "storage_key": "property/5684048244506624/019e4d76-22f1-7480-91b3-2a03fdc24f18.webp",
    "width": 3072,
    "height": 1103
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e4d76-227b-72ab-b435-de84229f391b.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Domain at Founders Parc logo",
    "public_id": "019e4d76-227b-72ab-b435-de84229f391b",
    "storage_key": "property/5684048244506624/019e4d76-227b-72ab-b435-de84229f391b.webp",
    "width": 3072,
    "height": 1103
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#739eb5",
  "property_secondary_color": "#294d5b",
  "property_font_color": "#2e2a25",
  "property_color_4": "#000000",
  "property_color_3": "#ffffff",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "673 - 1458",
  "property_sqft_min": "673",
  "property_sqft_max": "1458",
  "property_price_range": "1520 - 2830",
  "property_price_min": "1520",
  "property_price_max": "2830",
  "property_available_units": 19,
  "property_facebook_url": "https://www.facebook.com/domainfoundersparc/",
  "property_instagram_url": "https://www.instagram.com/domainatfoundersparc/?hl=en",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ8fzP6HV_ToYRSlcf5BNcCDQ",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/domain-at-founders-parc-euless",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Amenities that keep the day moving.</strong> At Domain at Founders Parc, recharge by the resort-inspired pool, gather around the fire pit or outdoor kitchen, stay on track in the fitness studio with yoga and spin space, or settle into the cyber café and conference room. At home, stainless-steel appliances, wood-style flooring, in-home laundry, and walk-in closets add everyday polish, with select layouts offering kitchen islands, wine racks, tile backsplashes, and soaking tubs.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with room to do more.</strong> Choose from focused one-, two-, and three-bedroom layouts in Euless, each designed around open living areas and everyday ease. Stainless-steel appliances, in-home washer and dryer, wood-style flooring, and large closets set the tone, while select homes add kitchen islands, wine racks, garden-style tubs, tile backsplashes, or private outdoor space.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture Domain at Founders Parc in detail.</strong> Preview sunlit living rooms with private outdoor space, island kitchens with sleek appliances and tile accents, and bedrooms with generous closet space. Then step into the community scene: poolside cabanas, fireside seating, a bright cyber café, a fitness studio, and polished lounges framed by large windows. Browse the full gallery to see more angles of apartment and amenity spaces in Euless.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Mid-Cities convenience, Founders Parc energy.</strong> Set within Euless’s mixed-use Founders Parc district, Domain at Founders Parc puts restaurants, retail, water features, and everyday essentials close to home. From here, it’s easy to reach Airport Freeway, Texas Star Golf Course, the new Mid-Cities H-E-B near Glade Parks, and Grapevine Main with TEXRail access to DFW Airport and downtown Fort Worth.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents praise the everyday ease at Domain at Founders Parc.</strong> Reviews highlight quiet surroundings, clean spaces, modern apartments, and inviting common areas for relaxing, reading, working, or unwinding. The leasing and maintenance teams earn frequent shoutouts for clear communication, quick responses, and service that feels personal from tour to move-in. Read more to see what stands out most.</p>",
  "property_neighborhood_blurb": "<p><strong>A connected Mid-Cities address with room to roam.</strong> From Domain at Founders Parc, you’re placed inside Euless’s Founders Parc district—a mixed-use setting shaped by retail, restaurants, residential streets, and water features—so the neighborhood feels useful before you even reach Airport Freeway.</p><p>Zoom out on the map and the appeal widens: grab dinner close to home, tee off at Texas Star, stock up at the new Mid-Cities H-E-B near Glade Parks, or head to Grapevine Main for TEXRail access toward DFW Airport and downtown Fort Worth. When the day winds down, come back to a polished apartment community with outdoor hangout spaces and <a href=\"/amenities\">resident amenities</a> that keep the easygoing rhythm going.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity-rich apartment living, inside and out.</strong> At Domain at Founders Parc, your day can move easily from a focused session in the cyber café or conference room to a workout in the fitness studio with yoga and spin space, then an evening by the resort-inspired pool, fire pit, or outdoor kitchen. Four-legged companions get their own perks, too, with a resident dog park and dog wash.</p><p>Inside your home, polished finishes keep everyday routines feeling streamlined: stainless-steel appliances, wood-style flooring, in-home washer and dryer, walk-in closets, and select details like kitchen islands, wine racks, tile backsplashes, and garden-style soaking tubs. Explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how these Euless apartment amenities come together.</p>",
  "property_applynow_blurb": "<p><strong>Find your fit at Domain at Founders Parc.</strong> Start your online application for a recently renovated one-, two-, or three-bedroom apartment in the heart of Euless, with polished finishes like stainless-steel appliances, wood-style flooring, large closets, and an in-home washer and dryer.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Contact the leasing team at Domain at Founders Parc for help exploring modern one-, two-, and three-bedroom apartment living in the heart of Euless, from renovated interiors to everyday conveniences in a mixed-use setting.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Domain at Founders Parc?</strong> Start here for quick answers on the community, leasing, apartment features, amenities, and everyday living in our recently renovated Euless setting. If you need more details, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Compare layouts that work as hard as they relax.</strong> Domain at Founders Parc gives you a focused range of one-, two-, and three-bedroom apartment floor plans in Euless, from streamlined one-bedroom homes to roomier multi-bedroom options with space to spread out.</p><p>As you browse availability, look for the details that shape everyday comfort: open living areas, stainless-steel kitchen appliances, in-home washer and dryer, wood-style flooring, large closets, and select layouts with kitchen islands, wine racks, garden-style tubs, tile backsplashes, or private outdoor space. Use the floor plan cards to compare pricing and availability, then explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite layout in person.</p>",
  "property_gallery_blurb": "<p><strong>See the spaces from every angle.</strong> Browse the Domain at Founders Parc photo gallery for a closer look at apartments and amenities in Euless—from sunlit living rooms that open to private outdoor space to kitchens with islands, sleek appliances, and tile accents. The images also bring the community setting into focus: cabanas beside the pool, warm seating around the fire pit, and lounge areas framed by large windows and refined finishes.</p><p>As you scroll, picture how each scene could fit your day: coffee in the cyber café, a focused workout in the fitness studio, or a quiet moment in a bedroom with generous closet space. When a photo catches your eye, compare <a href=\"/floor-plans\">available layouts</a> or explore <a href=\"/virtual-tours\">virtual tours</a> for a deeper look.</p>",
  "property_interactivemap_blurb": "<p><strong>Find your place in Euless.</strong> Use the interactive map to explore available apartments at Domain at Founders Parc and see what surrounds this mixed-use Hurst/Euless/Bedford location—from everyday shopping and dining to nearby parks, golf, major roadways, DFW Airport, and Grapevine access.</p>",
  "property_pets_blurb": "<p><strong>Bring the pets, keep the routine easy.</strong> At Domain at Founders Parc, your cats or dogs can settle in alongside you, with pet-friendly apartment living that goes beyond the policy details. Head to the resident dog park when it’s time to burn off energy, stop by the on-site dog wash after messy outdoor moments, and come home to finishes that help daily care feel simpler.</p><p>Hard-surface flooring, in-home laundry, and generous closet space make room for leashes, toys, towels, and everything else that comes with a well-loved companion. For a closer look at pet-friendly spaces and community perks, explore the <a href=\"/amenities\">amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Domain at Founders Parc in person.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Euless lifestyle you love.</strong> Invite friends to discover recently renovated apartment living with modern finishes, spacious layouts, and resort-style spaces that make everyday life feel effortless. Send a referral today and let them see what makes Domain at Founders Parc feel like home.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Domain at Founders Parc.</strong><br>Log in to pay rent, submit maintenance requests, and manage your account with ease—so you can get back to enjoying modern apartment living in a recently renovated Euless community.</p>",
  "property_reviews_blurb": "<p><strong>See why residents recommend Domain at Founders Parc.</strong> As you read through the reviews, you’ll notice the same themes again and again: quiet surroundings, clean spaces, modern apartments, and common areas residents love for relaxing, reading, working, or unwinding.</p><p>You’ll also see frequent praise for the people behind the experience. Reviewers call out Yevette/Ivette, Jilisa, Krystal, and Danielle for professionalism, clear communication, and helpful, personalized service from touring through move-in. Maintenance earns appreciation, too, with residents noting fast, courteous responses. As one reviewer shared, the team made them feel “truly valued.” Browse the reviews below to hear directly from residents about life at Domain at Founders Parc.</p>",
  "property_created_at": "1752256504288",
  "property_scheduletour_blurb": "<p><strong>See Domain at Founders Parc in person.</strong> Tour recently renovated apartments with stainless-steel appliances, wood-style flooring, in-home laundry, and large closets, then explore the resort-style spaces that make home feel like a destination. Schedule your visit today and picture your next move in the heart of Euless.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong><br>Our leasing team will follow up soon. In the meantime, picture modern apartment living in the heart of Euless, with renovated one-, two-, and three-bedroom layouts, stylish finishes, and resort-style spaces that make Domain at Founders Parc feel like home.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside the community tour before you visit.</strong> Explore Domain at Founders Parc from wherever you are, moving through shared spaces at your own pace and getting a clearer feel for the finishes, scale, and everyday flow that photos can only hint at. The Community virtual tour helps you preview the atmosphere, notice the details, and decide what you want to see next when you visit in Euless.</p><p>After your walkthrough, browse the <a href=\"/gallery\">photo gallery</a> for more angles, compare <a href=\"/floor-plans\">available floor plans</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Domain at Founders Parc in person.</p>",
  "property_copyright": "2025 All Rights Reserved. Domain at Founders Parc",
  "property_seo_title_home": "Domain at Founders Parc | Apartments in Euless, TX",
  "property_seo_description_home": "Experience the perfect blend of comfort and style at Domain at Founders Parc in Euless, TX. Our thoughtfully designed one, two, and three-bedroom apartments feature modern amenities like vaulted ceilings, premium quartz countertops, and garden tubs. With a dog park, fitness center, and inviting pool area, you'll find plenty of space to unwind. Designed for convenience, enjoy online resident services and a fully equipped kitchen, complete with stylish kitchen islands and appliances. Elevate your lifestyle today and make our vibrant community your new home!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Euless, TX",
  "property_seo_description_floorplans": "Unlock the ideal living space at Domain at Founders Parc in Euless, TX. With a variety of thoughtfully designed floor plans—including one, two, and three-bedroom options—there's a perfect home waiting for you. Dive into our diverse layouts and envision your life in a community where comfort meets style. Browse our apartment homes today to find your perfect match!",
  "property_seo_title_amenities": "Amenities | Euless, TX Apartments for Rent",
  "property_seo_description_amenities": "\"Welcome to Domain at Founders Parc in Euless, TX, where comfort meets luxury. Choose from thoughtfully designed one, two, or three-bedroom apartments featuring modern amenities like a refreshing pool, a state-of-the-art fitness center, and elegant garden tubs. Enjoy socializing in our dog park, entertaining around the fire pit, or unwinding with a glass of wine in our lounge. With online resident services and premium finishes like gray and white quartz countertops, life here is a blend of leisure and convenience. Come experience the vibrant community that awaits you!\"",
  "property_seo_title_gallery": "Gallery | Apartments in Euless, TX",
  "property_seo_description_gallery": "Step into your future at Domain at Founders Parc in Euless, TX, where inviting one, two, and three-bedroom floor plans meet exceptional amenities. Envision relaxing by our sparkling pool, unwinding by the fire pit, or breaking a sweat at the state-of-the-art fitness center. With sophisticated finishes like vaulted ceilings and quartz countertops, plus a dog park and online resident services, this community is designed for modern living. Picture yourself living here; browse our captivating photo gallery today!",
  "property_seo_title_virtualtours": "Virtual Tours | Domain at Founders Parc Apartments",
  "property_seo_description_virtualtours": "Step into the vibrant lifestyle at Domain at Founders Parc in Euless, TX. From cozy one-bedroom retreats to spacious three-bedroom homes, our thoughtfully designed floor plans cater to your every need. Ready to envision your future here? Take a virtual tour and experience the essence of comfortable living today!",
  "property_seo_title_interactivemap": "Interactive Map | Domain at Founders Parc Apartments",
  "property_seo_description_interactivemap": "\"Unearth your ideal living space at Domain at Founders Parc in Euless, TX. With thoughtfully designed one, two, and three-bedroom apartments, luxurious amenities like a cozy fire pit, modern fitness center, and inviting pool, your perfect home awaits. Enjoy the ease of online resident services, spacious walk-in closets, and stunning kitchen finishes, all complemented by a vibrant community featuring dog parks and lush gardens. Navigate our interactive community map to find your dream apartment with ease. Your new lifestyle is just a click away!\"",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Euless, TX",
  "property_seo_description_neighborhood": "Uncover the vibrant lifestyle awaiting you at Domain at Founders Parc in Euless, TX. Nestled in a dynamic neighborhood, our community offers an array of local favorites and exciting points of interest just steps away. Whether you’re looking for charming cafes, stylish shops, or serene parks, the perfect blend of convenience and adventure is at your doorstep. See what's around our community and embrace the energy of your new home!",
  "property_seo_title_contact": "Contact Us | Domain at Founders Parc",
  "property_seo_description_contact": "Experience modern living at Domain at Founders Parc in Euless, TX, where comfort meets style. Whether you’re searching for a cozy one-bedroom or a spacious three-bedroom apartment, we have a variety of floor plans designed to suit your lifestyle. Have questions? Our friendly leasing team is ready to assist you—reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Euless, TX",
  "property_seo_description_faqs": "\"Unlock a world of comfort at Domain at Founders Parc in Euless, TX! With floor plans that range from one to three bedrooms, our community boasts premium amenities including a serene dog park, a state-of-the-art fitness center, and a refreshing pool. Whether you’re enjoying a cozy evening by the fire pit or working in the cyber cafe, we cater to your lifestyle. Have questions? Visit our FAQs page to discover everything you need to know about crafting your perfect home with us!\"",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Euless, TX",
  "property_seo_description_reviews": "\"Experience the charm of Domain at Founders Parc in Euless, TX, where modern living meets vibrant community life. Our residents enjoy spacious one, two, and three-bedroom floor plans, luxurious amenities, and serene outdoor spaces. From cozy fire pits to a state-of-the-art fitness center, see why our community is the ideal backdrop for your lifestyle! Check out resident reviews and find out what makes us home!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Euless, TX",
  "property_seo_description_applynow": "Step into luxury at Domain at Founders Parc in Euless, TX, where your ideal apartment awaits! Offering one, two, and three-bedroom floor plans equipped with premium features like granite countertops, vaulted ceilings, and spacious walk-in closets, your new home is designed for modern living. Enjoy exclusive amenities including a resort-style pool, dog park, fitness center, and stylish lounge—perfect for unwinding and entertaining. With online resident services and move-in-ready options, leasing your dream space has never been easier. Apply now and elevate your lifestyle today!",
  "property_seo_title_residentaccess": "Resident Access | Domain at Founders Parc",
  "property_seo_description_residentaccess": "Unlock seamless living at Domain at Founders Parc in Euless, TX! Sign in to your resident portal to effortlessly manage rent payments, schedule maintenance, and stay connected with your community. Your convenience is just a click away!",
  "property_seo_title_referafriend": "Refer A Friend | Domain at Founders Parc",
  "property_seo_description_referafriend": "\"Great friends make great neighbors! Refer a friend to Domain at Founders Parc in Euless, TX, and enjoy the perks of living in a vibrant community where connections thrive. Share the experience and enjoy exclusive rewards together!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Domain at Founders Parc",
  "property_seo_description_scheduletour": "\"Step into a world of comfort and style at Domain at Founders Parc in Euless, TX. Uncover your dream apartment with stunning amenities and a vibrant community atmosphere. Schedule a tour today and envision your new life here!\"",
  "property_seo_title_privacy": "Privacy Policy | Domain at Founders Parc",
  "property_seo_description_privacy": "\"At Domain at Founders Parc in Euless, TX, your privacy matters. Our commitment to safeguarding your information is reflected in our transparent privacy policy. Dive into the details and see how we protect your peace of mind. View our privacy policy today!\"",
  "property_seo_title_accessibility": "Website Accessibility | Domain at Founders Parc",
  "property_seo_description_accessibility": "\"At Domain at Founders Parc in Euless, TX, we prioritize accessibility for all. Our commitment to digital inclusion ensures everyone can navigate our community with ease. Join us in creating a welcoming environment where everyone belongs.\"",
  "property_seo_title_sitemap": "Sitemap | Domain at Founders Parc",
  "property_seo_description_sitemap": "\"Navigate your future at Domain at Founders Parc in Euless, TX. Our comprehensive sitemap guides you through luxury amenities, vibrant community events, and the unique lifestyle waiting for you. Uncover your ideal home seamlessly!\"",
  "property_seo_title_thankyou": "Thank You | Domain at Founders Parc",
  "property_seo_description_thankyou": "Thank you for reaching out to Domain at Founders Parc in Euless, TX! Your interest means the world to us. One of our dedicated team members will connect with you soon to help you discover the perfect space to call home in our vibrant community. Stay tuned for your next step to an exceptional living experience!",
  "property_seo_title_pets": "Pet Policy | Apartments in Austell, GA\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234319689",
  "amenities": [
    {
      "id": "custom_47929252-0336-4348-90ed-f99f192eb81a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1202a064-b015-4603-a107-376b1d329a4f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "external_id": "P000000609",
      "title": "Cabinets",
      "amount": "0.0000",
      "description": "Contemporary Cabinetry",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_71e76ccb-4c5d-4248-bd64-129b668452c3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Sleek Quartz Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d9f23ceb-ee74-491e-aa88-89aef95fae73",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "external_id": "P000000625",
      "title": "Digital Thermostats",
      "amount": "0.0000",
      "description": "NEST Thermostats",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_47aec031-e3af-43aa-b2d9-fce5f419e4de",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e97730a9-f9a4-4faf-94a9-89277023786a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "external_id": "P000000634",
      "title": "Fire Pit",
      "amount": "0.0000",
      "description": "In-Ground Fire Pit & Outdoor Kitchen",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9dd107d0-4942-42dd-b78e-e06546da739e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern Fitness Studio w/ Yoga & Spin Room",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7c3c6d63-204f-429b-b7f6-54121bb16e90",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "external_id": "P000000641",
      "title": "Garden Tub",
      "amount": "0.0000",
      "description": "Garden Style Soaking Tubs",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fbb996a8-b7de-47eb-9e32-1a7a1d21ca6c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood Style Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e39b1be6-a719-4716-9d3e-75d225a9ed20",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_57f17425-5993-4177-b799-5e6fa92e887d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "external_id": "P000000652",
      "title": "Kitchen Islands",
      "amount": "0.0000",
      "description": "Kitchen Islands*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5dddda75-0e1d-4d8c-acfd-1f6632c1f7f5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_106b1c74-60ea-4d3a-af91-e3095414b611",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Inspired Pool w/ Cabanas & Water Feature",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2061fff5-2c58-434d-82a9-5b86e21c4502",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ecc410be-00f7-4408-9276-86c84d3ad14d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Decorative Ceramic or Glass Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b7326e7c-d233-47a9-a51a-4a201852acaa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_68cc1c16-60ac-4b6b-b0dc-e9b7c34d3aab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Generous Walk-In Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_18d0f89a-f683-40c9-bc5e-a125bd930646",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "external_id": "P000001372",
      "title": "Lounge",
      "amount": "0.0000",
      "description": "Resident Lounge",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6ed0f8bd-16f8-4777-a49e-75040ffeb4a4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "external_id": "P000002333",
      "title": "Wine Rack",
      "amount": "0.0000",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c6cf78ab-b652-4edf-8090-ef8cccd7cefd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "external_id": "P000002365",
      "title": "Conference Room",
      "amount": "0.0000",
      "description": "Conference Rooms",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fd5103d7-74d4-4e01-b778-719e8e596e22",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "external_id": "P000002384",
      "title": "Cyber Cafe",
      "amount": "0.0000",
      "description": "Cyber Lounge & Coffee Bar",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_3d19308f-fcc4-4e4f-8f4e-0c7447cdf38c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-57a5-719a-86ef-659878b3db5a.webp",
      "image_media": {
        "alt_text": "Stylishly decorated living room with a sofa, accent chairs, coffee tables, and wall art.",
        "public_id": "019e8991-57a5-719a-86ef-659878b3db5a",
        "storage_key": "property/5684048244506624/019e8991-57a5-719a-86ef-659878b3db5a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Explore this beautifully appointed living space, perfect for relaxation and entertaining. Features a comfortable sofa, elegant accent chairs, and tasteful decor.",
      "link": "",
      "alt_text": "Stylishly decorated living room with a sofa, accent chairs, coffee tables, and wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8870e2ef-861c-4627-807b-07955fecbea5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-51de-70bb-8c29-0c55c43b3924.webp",
      "image_media": {
        "alt_text": "Lobby seating area with green velvet chairs, a coffee station, and a business center.",
        "public_id": "019e8991-51de-70bb-8c29-0c55c43b3924",
        "storage_key": "property/5684048244506624/019e8991-51de-70bb-8c29-0c55c43b3924.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax in our beautifully appointed lobby, featuring comfortable seating, a convenient coffee bar, and a fully equipped business center for your productivity needs.",
      "link": "",
      "alt_text": "Lobby seating area with green velvet chairs, a coffee station, and a business center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_62dceed5-16b8-48cb-9f81-86d06ac8a3b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-541d-7669-8d91-6516611e2547.webp",
      "image_media": {
        "alt_text": "Modern living room and open-concept kitchen with island seating.",
        "public_id": "019e8991-541d-7669-8d91-6516611e2547",
        "storage_key": "property/5684048244506624/019e8991-541d-7669-8d91-6516611e2547.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area with a comfortable sectional sofa and a sleek, open-plan kitchen featuring stainless steel appliances and ample counter space.",
      "link": "",
      "alt_text": "Modern living room and open-concept kitchen with island seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_38912796-04fb-4dd7-b924-2cec766ab52a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-5091-72b9-8fed-f3c0f6946786.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, two framed abstract art pieces, a ceiling fan, and a large window with blinds.",
        "public_id": "019e8991-5091-72b9-8fed-f3c0f6946786",
        "storage_key": "property/5684048244506624/019e8991-5091-72b9-8fed-f3c0f6946786.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, elegant wall art, and ample natural light from the large window. Perfect for relaxation and a peaceful night's sleep.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, two framed abstract art pieces, a ceiling fan, and a large window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_610349a3-0112-4a1f-a3df-d2894bd4c3ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-53c3-76fa-bdd2-06c3ca7f3bfc.webp",
      "image_media": {
        "alt_text": "Community lounge area with a large island bar and modern pendant lighting.",
        "public_id": "019e8991-53c3-76fa-bdd2-06c3ca7f3bfc",
        "storage_key": "property/5684048244506624/019e8991-53c3-76fa-bdd2-06c3ca7f3bfc.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy our stylish community lounge, perfect for socializing or relaxing, featuring a large island bar and comfortable seating.",
      "link": "",
      "alt_text": "Community lounge area with a large island bar and modern pendant lighting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c5b9b5f9-79fe-4d2e-b563-4bebe1d93626",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-4c8d-75ed-a6bb-5763b589c538.webp",
      "image_media": {
        "alt_text": "Interior view of a modern apartment gym with cardio machines, weight training equipment, and medicine balls.",
        "public_id": "019e8991-4c8d-75ed-a6bb-5763b589c538",
        "storage_key": "property/5684048244506624/019e8991-4c8d-75ed-a6bb-5763b589c538.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with everything you need for a comprehensive workout.",
      "link": "",
      "alt_text": "Interior view of a modern apartment gym with cardio machines, weight training equipment, and medicine balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c620319b-2538-43c7-9350-d66066338348",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-484e-7645-b8c3-64ce9943f3f8.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with in-water loungers and lounge chairs surrounding the pool.",
        "public_id": "019e8991-484e-7645-b8c3-64ce9943f3f8",
        "storage_key": "property/5684048244506624/019e8991-484e-7645-b8c3-64ce9943f3f8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, featuring comfortable in-water loungers and ample lounge seating for ultimate relaxation.",
      "link": "",
      "alt_text": "Resort-style swimming pool with in-water loungers and lounge chairs surrounding the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_adb0f94d-ba28-4d78-85a8-130326a93372",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-4bf6-71d4-8344-22e2b99c2a21.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with balconies and landscaping.",
        "public_id": "019e8991-4bf6-71d4-8344-22e2b99c2a21",
        "storage_key": "property/5684048244506624/019e8991-4bf6-71d4-8344-22e2b99c2a21.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment building, showcasing its architecture, balconies, and well-maintained landscaping.",
      "link": "",
      "alt_text": "Modern apartment building exterior with balconies and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_145e319e-07d3-45be-980c-57fab56e0c73",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-4cb5-75da-ac7a-7ffaba019828.webp",
      "image_media": {
        "alt_text": "Covered seating area with a sectional couch and a lounge chair next to a pool.",
        "public_id": "019e8991-4cb5-75da-ac7a-7ffaba019828",
        "storage_key": "property/5684048244506624/019e8991-4cb5-75da-ac7a-7ffaba019828.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax in our covered outdoor lounge area, perfect for unwinding by the pool.",
      "link": "",
      "alt_text": "Covered seating area with a sectional couch and a lounge chair next to a pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4438198a-e2f2-422f-90ee-760ce4473b21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-48b8-705d-99b2-98e78a86ee9d.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, walk-in closet, and glass-enclosed shower.",
        "public_id": "019e8991-48b8-705d-99b2-98e78a86ee9d",
        "storage_key": "property/5684048244506624/019e8991-48b8-705d-99b2-98e78a86ee9d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a double vanity, ample storage in the walk-in closet, and a sleek glass-enclosed shower for a spa-like experience.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity, walk-in closet, and glass-enclosed shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_202b2140-393c-48a2-9e41-221bf4277863",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-3cbd-70cb-8cd8-18f03755527a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, a large island with bar stools, and a dining area.",
        "public_id": "019e8991-3cbd-70cb-8cd8-18f03755527a",
        "storage_key": "property/5684048244506624/019e8991-3cbd-70cb-8cd8-18f03755527a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring stainless steel appliances, ample cabinet space, a spacious island with seating, and an adjacent dining area perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, a large island with bar stools, and a dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5aa82a2a-f85a-4f54-b118-23fe14875a21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-2aed-73fa-831f-2c310389f266.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, modern art, and a ceiling fan.",
        "public_id": "019e8991-2aed-73fa-831f-2c310389f266",
        "storage_key": "property/5684048244506624/019e8991-2aed-73fa-831f-2c310389f266.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed adorned with decorative pillows, striking modern wall art, and a refreshing ceiling fan for ultimate comfort.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, modern art, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8ed768f3-fe63-4893-afa1-8c20eeb37725",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-2ee9-7003-9091-63e5236c5cf8.webp",
      "image_media": {
        "alt_text": "Luxury apartment complex courtyard with swimming pool and lounge chairs.",
        "public_id": "019e8991-2ee9-7003-9091-63e5236c5cf8",
        "storage_key": "property/5684048244506624/019e8991-2ee9-7003-9091-63e5236c5cf8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling swimming pool at our luxury apartment community. Enjoy plush lounge seating and a resort-style atmosphere.",
      "link": "",
      "alt_text": "Luxury apartment complex courtyard with swimming pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a633877b-c1ca-49b5-887e-7c62174d3434",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-2c92-74ae-a878-11275f268b86.webp",
      "image_media": {
        "alt_text": "Pool table in a community lounge with a bar and seating area.",
        "public_id": "019e8991-2c92-74ae-a878-11275f268b86",
        "storage_key": "property/5684048244506624/019e8991-2c92-74ae-a878-11275f268b86.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a game of pool in our vibrant community lounge, featuring a modern bar and comfortable seating.",
      "link": "",
      "alt_text": "Pool table in a community lounge with a bar and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_20c9b016-5e7d-4af5-ac41-0ce4fe4023f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-246a-759b-8790-d9b28d7e3ec0.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex with multiple buildings, surrounded by trees and a pond.",
        "public_id": "019e8991-246a-759b-8790-d9b28d7e3ec0",
        "storage_key": "property/5684048244506624/019e8991-246a-759b-8790-d9b28d7e3ec0.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Discover spacious living in our beautiful apartment community. Enjoy the modern architecture and lush surroundings.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex with multiple buildings, surrounded by trees and a pond.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8ba0cede-7d5a-46f8-a566-1b4d1bbd8701",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-282f-765c-9ade-463d570b2930.webp",
      "image_media": {
        "alt_text": "Spin bikes and exercise equipment in the property's fitness center.",
        "public_id": "019e8991-282f-765c-9ade-463d570b2930",
        "storage_key": "property/5684048244506624/019e8991-282f-765c-9ade-463d570b2930.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring spin bikes, free weights, and yoga balls.",
      "link": "",
      "alt_text": "Spin bikes and exercise equipment in the property's fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cbea790e-3954-4034-a77b-05ab56c9ba74",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-208a-722d-9889-5e304df65dd0.webp",
      "image_media": {
        "alt_text": "Modern lounge area with leather chairs and coffee tables.",
        "public_id": "019e8991-208a-722d-9889-5e304df65dd0",
        "storage_key": "property/5684048244506624/019e8991-208a-722d-9889-5e304df65dd0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating, a large television, and elegant decor. Perfect for socializing or enjoying a quiet moment.",
      "link": "",
      "alt_text": "Modern lounge area with leather chairs and coffee tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_43f6bedc-7212-49ea-b7e7-1da69b9b94ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-27d5-75e2-8904-e25e393154f4.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee tables, and art on the walls, leading into the kitchen.",
        "public_id": "019e8991-27d5-75e2-8904-e25e393154f4",
        "storage_key": "property/5684048244506624/019e8991-27d5-75e2-8904-e25e393154f4.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Stylish living room with modern art and comfortable seating, seamlessly flowing into a fully equipped kitchen with a breakfast bar.",
      "link": "",
      "alt_text": "Living room with a sofa, coffee tables, and art on the walls, leading into the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ca3c039b-b7c8-4e92-9e78-4bd22574b136",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-1eb1-757d-849f-870fb0661fb3.webp",
      "image_media": {
        "alt_text": "Conference room with a long white table and plush leather chairs, TV on the wall, and a large window.",
        "public_id": "019e8991-1eb1-757d-849f-870fb0661fb3",
        "storage_key": "property/5684048244506624/019e8991-1eb1-757d-849f-870fb0661fb3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Host your next meeting or event in our stylish conference room, perfect for business or social gatherings.",
      "link": "",
      "alt_text": "Conference room with a long white table and plush leather chairs, TV on the wall, and a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bd7592a9-f023-438e-9daa-9cba9c38c756",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-2018-769f-8bed-d3e8db6fe63f.webp",
      "image_media": {
        "alt_text": "Interior lobby with comfortable seating, a tufted leather banquette, and decorative console table.",
        "public_id": "019e8991-2018-769f-8bed-d3e8db6fe63f",
        "storage_key": "property/5684048244506624/019e8991-2018-769f-8bed-d3e8db6fe63f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in the beautifully designed lobby, featuring plush seating and elegant decor for a welcoming atmosphere.",
      "link": "",
      "alt_text": "Interior lobby with comfortable seating, a tufted leather banquette, and decorative console table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dd837057-9a6d-4d46-91c7-cca7c7805b44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-23a1-74b3-85e1-7700cb9b576d.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with seating and stainless steel appliances.",
        "public_id": "019e8991-23a1-74b3-85e1-7700cb9b576d",
        "storage_key": "property/5684048244506624/019e8991-23a1-74b3-85e1-7700cb9b576d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring a spacious island with bar seating, sleek cabinetry, and stainless steel appliances. Perfect for entertaining and everyday living.",
      "link": "",
      "alt_text": "Modern kitchen island with seating and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0740edff-1bd4-4874-9c78-a9404e981d79",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-06a1-711e-8d4c-9b011eb80e59.webp",
      "image_media": {
        "alt_text": "Dog park with playground equipment and covered parking area.",
        "public_id": "019e8991-06a1-711e-8d4c-9b011eb80e59",
        "storage_key": "property/5684048244506624/019e8991-06a1-711e-8d4c-9b011eb80e59.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our community dog park with playground for pets and convenient covered parking nearby.",
      "link": "",
      "alt_text": "Dog park with playground equipment and covered parking area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6e115720-1fa1-46c4-b71d-3b2baeaddd1f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-05e5-7459-8103-1ef68bcd6f84.webp",
      "image_media": {
        "alt_text": "Balcony with table and chair overlooking townhouses and a street.",
        "public_id": "019e8991-05e5-7459-8103-1ef68bcd6f84",
        "storage_key": "property/5684048244506624/019e8991-05e5-7459-8103-1ef68bcd6f84.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy morning coffee or evening relaxation on your private balcony, offering views of the charming neighborhood.",
      "link": "",
      "alt_text": "Balcony with table and chair overlooking townhouses and a street.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4642cd80-a17c-40bf-aac7-04aa3204af0b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-0499-711a-bdb2-cb2c139deff7.webp",
      "image_media": {
        "alt_text": "Community game room with foosball table, poker table, and shuffleboard.",
        "public_id": "019e8991-0499-711a-bdb2-cb2c139deff7",
        "storage_key": "property/5684048244506624/019e8991-0499-711a-bdb2-cb2c139deff7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy endless fun in our community game room, featuring a foosball table, poker table, and shuffleboard.",
      "link": "",
      "alt_text": "Community game room with foosball table, poker table, and shuffleboard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6d3386e7-a28a-4c1e-bdc3-a93e63b35cd9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-07c5-7170-9b49-d85c476c7be5.webp",
      "image_media": {
        "alt_text": "Modern coworking space with private workstations and comfortable seating.",
        "public_id": "019e8991-07c5-7170-9b49-d85c476c7be5",
        "storage_key": "property/5684048244506624/019e8991-07c5-7170-9b49-d85c476c7be5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our stylish coworking space, equipped with private workstations and plush seating, perfect for productivity and relaxation.",
      "link": "",
      "alt_text": "Modern coworking space with private workstations and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c336d2bd-5ba9-4f03-9930-674978bf4ff0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-0539-76b9-91aa-586116adc036.webp",
      "image_media": {
        "alt_text": "Bathroom with walk-in closet, vanity, toilet, and shower.",
        "public_id": "019e8991-0539-76b9-91aa-586116adc036",
        "storage_key": "property/5684048244506624/019e8991-0539-76b9-91aa-586116adc036.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a spacious vanity with a white countertop, elegant dark wood cabinetry, and a large mirror. Includes a walk-in closet and a tiled shower.",
      "link": "",
      "alt_text": "Bathroom with walk-in closet, vanity, toilet, and shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_07e21618-849f-4478-a3a6-b6c6b378d342",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-04d6-7184-b8c1-c2cc3ee8c100.webp",
      "image_media": {
        "alt_text": "Stacked washer and dryer in a closet next to a kitchen island.",
        "public_id": "019e8991-04d6-7184-b8c1-c2cc3ee8c100",
        "storage_key": "property/5684048244506624/019e8991-04d6-7184-b8c1-c2cc3ee8c100.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Conveniently located stacked washer and dryer in a spacious closet, adjacent to a modern kitchen island with a sink.",
      "link": "",
      "alt_text": "Stacked washer and dryer in a closet next to a kitchen island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bfa2813b-27c7-4a85-ab5c-3708c2e3e637",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-046f-7185-9c39-238707581f50.webp",
      "image_media": {
        "alt_text": "Treadmills in a modern gym with motivational word art on the wall.",
        "public_id": "019e8991-046f-7185-9c39-238707581f50",
        "storage_key": "property/5684048244506624/019e8991-046f-7185-9c39-238707581f50.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with treadmills and inspiring decor.",
      "link": "",
      "alt_text": "Treadmills in a modern gym with motivational word art on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a57d58a4-01be-473c-afce-ece310649665",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-049f-7392-aa9d-c61a0edecbe6.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, vanity, and walk-in closet.",
        "public_id": "019e8991-049f-7392-aa9d-c61a0edecbe6",
        "storage_key": "property/5684048244506624/019e8991-049f-7392-aa9d-c61a0edecbe6.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Chic bathroom featuring a modern vanity, spacious walk-in closet, and elegant finishes.",
      "link": "",
      "alt_text": "Bathroom with toilet, vanity, and walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d11c2f2e-e016-4fd3-bd5e-1cf17fec267d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-046c-70ad-b7b3-478b1d56d852.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen and bar area with grills, counter space, and bar stools.",
        "public_id": "019e8991-046c-70ad-b7b3-478b1d56d852",
        "storage_key": "property/5684048244506624/019e8991-046c-70ad-b7b3-478b1d56d852.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and entertaining in our community's well-equipped outdoor kitchen and bar area, featuring built-in grills and ample seating.",
      "link": "",
      "alt_text": "Outdoor kitchen and bar area with grills, counter space, and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_18ce218e-7d21-40eb-9e07-dab3efb178e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-04b3-7153-865f-d91d73331829.webp",
      "image_media": {
        "alt_text": "Modern living room with gray sectional sofa, blue armchair, coffee table, and large window.",
        "public_id": "019e8991-04b3-7153-865f-d91d73331829",
        "storage_key": "property/5684048244506624/019e8991-04b3-7153-865f-d91d73331829.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into comfort and style in this beautifully appointed living room, featuring a plush sectional, accent chair, and ample natural light.",
      "link": "",
      "alt_text": "Modern living room with gray sectional sofa, blue armchair, coffee table, and large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_d518b769-cad4-4174-bc28-4a088f3c7482",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Tassili Mediterranean Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "501 S Industrial Blvd, Euless, TX 76040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-4222-7799-b168-fbbf326b1b58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-4222-7799-b168-fbbf326b1b58",
        "storage_key": "property/5684048244506624/019f150d-4222-7799-b168-fbbf326b1b58.webp",
        "width": 842,
        "height": 1280
      },
      "poi_business_url": "https://www.tassilitx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17386941818824391456&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tassili-mediterranean-buffet--grill",
      "poi_latitude": "32.8315015",
      "poi_longitude": "-97.0992021",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 682-738-3096",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bd64-761f-98b0-38e7ef2b5971.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bd64-761f-98b0-38e7ef2b5971",
        "storage_key": "property/5684048244506624/019f150a-bd64-761f-98b0-38e7ef2b5971.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOb_INOl_ToYRIHtp2XbTSvE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_644068c5-d666-4cd1-988a-fd2fc940be52",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Yaksa Restaurant and Bar",
      "poi_type": "Restaurants",
      "poi_address": "501 S Industrial Blvd #220, Euless, TX 76040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-4752-70af-8273-9a80a6e4c63e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-4752-70af-8273-9a80a6e4c63e",
        "storage_key": "property/5684048244506624/019f150d-4752-70af-8273-9a80a6e4c63e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://yaksarestaurantandbar.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14726088418759956623&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yaksa-restaurant-and-bar",
      "poi_latitude": "32.831555",
      "poi_longitude": "-97.0991818",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 682-503-4748",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bd64-761f-98b0-38e7ef2b5971.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bd64-761f-98b0-38e7ef2b5971",
        "storage_key": "property/5684048244506624/019f150a-bd64-761f-98b0-38e7ef2b5971.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbTk3V8p_ToYRj1guC2WTXcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d39cb0a9-15a1-484c-a1b3-9b6313113fbf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "521 S Industrial Blvd, Euless, TX 76040, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-4751-76ea-9c15-69c9c27def3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-4751-76ea-9c15-69c9c27def3a",
        "storage_key": "property/5684048244506624/019f150d-4751-76ea-9c15-69c9c27def3a.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/tx/euless/521-south-industrial-boulevard",
      "poi_directions_map_url": "https://maps.google.com/?cid=9879289161217174732&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "32.8306127",
      "poi_longitude": "-97.0991948",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-345-4787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bd64-761f-98b0-38e7ef2b5971.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bd64-761f-98b0-38e7ef2b5971",
        "storage_key": "property/5684048244506624/019f150a-bd64-761f-98b0-38e7ef2b5971.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn5tBMsl_ToYRzGy3PyZJGok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_d0f5fb47-dd1f-43ef-ac8b-8e1a0c94f40e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Fuzzy's Taco Shop",
      "poi_type": "Restaurants",
      "poi_address": "1363 W Euless Blvd, Euless, TX 76040, USA",
      "poi_short_description": "Modern counter-service chain serving Baja-style tacos & other Mexican eats, plus beer & margaritas.",
      "poi_long_description": "Modern counter-service chain serving Baja-style tacos & other Mexican eats, plus beer & margaritas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-47ae-77d2-a1a2-2c468e30e57e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-47ae-77d2-a1a2-2c468e30e57e",
        "storage_key": "property/5684048244506624/019f150d-47ae-77d2-a1a2-2c468e30e57e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fuzzystacoshop.com/locations/texas/euless/?utm_campaign=google_maps&utm_medium=organic&utm_source=google&utm_content=website&utm_keyword=31401",
      "poi_directions_map_url": "https://maps.google.com/?cid=7555273789984056635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fuzzys-taco-shop",
      "poi_latitude": "32.8264018",
      "poi_longitude": "-97.1046739",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-267-8226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bd64-761f-98b0-38e7ef2b5971.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bd64-761f-98b0-38e7ef2b5971",
        "storage_key": "property/5684048244506624/019f150a-bd64-761f-98b0-38e7ef2b5971.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB5O-9jF-ToYRO6XRgHu52Wg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "taco_restaurant"
    },
    {
      "id": "custom_d3531ca5-45ad-4d8e-ae65-57c6860ea9cd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Saviano's Italian Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "300 N Main St, Euless, TX 76039, USA",
      "poi_short_description": "Family-run Italian stalwart presents a pizza-&-pasta lineup in rustic digs with an open kitchen.",
      "poi_long_description": "Family-run Italian stalwart presents a pizza-&-pasta lineup in rustic digs with an open kitchen.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-40fb-7200-996c-93a484364084.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-40fb-7200-996c-93a484364084",
        "storage_key": "property/5684048244506624/019f150d-40fb-7200-996c-93a484364084.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://savianositaliankitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11999126159553208971&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savianos-italian-kitchen",
      "poi_latitude": "32.8403252",
      "poi_longitude": "-97.082152",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-283-3121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bd64-761f-98b0-38e7ef2b5971.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bd64-761f-98b0-38e7ef2b5971",
        "storage_key": "property/5684048244506624/019f150a-bd64-761f-98b0-38e7ef2b5971.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqZ6xTXuAToYRiyJEA6t1haY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_c1c6c16a-d485-41c5-9018-7856c2aaee0a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Real Texas Cafe",
      "poi_type": "Restaurants",
      "poi_address": "2103 W Airport Fwy, Euless, TX 76040, USA",
      "poi_short_description": "Homey eatery featuring southern favorites such as chicken-fried steak and breakfast staples, plus pies.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-4479-7536-b2db-933f9bd0393a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-4479-7536-b2db-933f9bd0393a",
        "storage_key": "property/5684048244506624/019f150d-4479-7536-b2db-933f9bd0393a.webp",
        "width": 960,
        "height": 541
      },
      "poi_business_url": "https://realtexascafe.square.site/?fbclid=IwY2xjawGofAxleHRuA2FlbQIxMAABHbmlSYCBf7tylYNkJDvRHiQg2Sv4njXcwsFPDov8YU2k0tS9ECIrhxpAdw_aem_JkZse30zMfa8XkRxipi15g#FYT63J2LS6ARRXWUW7OFFEBE",
      "poi_directions_map_url": "https://maps.google.com/?cid=16180190315944983062&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "real-texas-cafe",
      "poi_latitude": "32.83674260000001",
      "poi_longitude": "-97.1177132",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-554-3004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bd64-761f-98b0-38e7ef2b5971.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bd64-761f-98b0-38e7ef2b5971",
        "storage_key": "property/5684048244506624/019f150a-bd64-761f-98b0-38e7ef2b5971.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQcWmgHd_ToYRFrodtF2Vi-A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_36d1b6ba-8d02-47e0-982c-f80b0cbe7b8a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Yichiban Buffet",
      "poi_type": "Restaurants",
      "poi_address": "1201 Airport Fwy, Euless, TX 76040, USA",
      "poi_short_description": "Clean eatery dishing up crab legs, roast pork and other Chinese fare via an all-you-can-eat buffet.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-4285-713a-81e7-e9b2f5d79a9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-4285-713a-81e7-e9b2f5d79a9f",
        "storage_key": "property/5684048244506624/019f150d-4285-713a-81e7-e9b2f5d79a9f.webp",
        "width": 665,
        "height": 375
      },
      "poi_business_url": "https://yichibanbuffet.shop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7510344109919925438&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yichiban-buffet",
      "poi_latitude": "32.8365433",
      "poi_longitude": "-97.1008663",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-283-1882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bd64-761f-98b0-38e7ef2b5971.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bd64-761f-98b0-38e7ef2b5971",
        "storage_key": "property/5684048244506624/019f150a-bd64-761f-98b0-38e7ef2b5971.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUfbZWtJ_ToYRvnS5LC0aOmg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_restaurant"
    },
    {
      "id": "custom_9f5a7607-510d-4238-8f4a-26aa31d1c1ea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Imperial Hibachi & Sushi",
      "poi_type": "Restaurants",
      "poi_address": "1320 Chisholm Trail #600, Euless, TX 76039, USA",
      "poi_short_description": "Familiar grill-sushi hybrid with contemporary decor & flamboyant chefs in the dining room.",
      "poi_long_description": "Familiar grill-sushi hybrid with contemporary decor & flamboyant chefs in the dining room.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-412a-7344-87ba-c71fc1863102.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-412a-7344-87ba-c71fc1863102",
        "storage_key": "property/5684048244506624/019f150d-412a-7344-87ba-c71fc1863102.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://imperialhibachiandsushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10877156276109041438&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "imperial-hibachi--sushi",
      "poi_latitude": "32.8751129",
      "poi_longitude": "-97.1039037",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-907-1771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bd64-761f-98b0-38e7ef2b5971.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bd64-761f-98b0-38e7ef2b5971",
        "storage_key": "property/5684048244506624/019f150a-bd64-761f-98b0-38e7ef2b5971.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcW61mbl_ToYRHt_j4wBs85Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6b2ab1a4-b764-4bfe-883c-c41831c5a1ac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Society Coffee",
      "poi_type": "Restaurants",
      "poi_address": "600 N Main St, Euless, TX 76039, USA",
      "poi_short_description": "Cozy spot offering coffee, tea, and prepared foods inside a gas station.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-42f8-7148-8761-62c9b8145f2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-42f8-7148-8761-62c9b8145f2a",
        "storage_key": "property/5684048244506624/019f150d-42f8-7148-8761-62c9b8145f2a.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://societycoffee.co/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12659715261152909545&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "society-coffee",
      "poi_latitude": "32.84432",
      "poi_longitude": "-97.082258",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-282-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150e-16b6-770f-8f96-06346708a8ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-16b6-770f-8f96-06346708a8ee",
        "storage_key": "property/5684048244506624/019f150e-16b6-770f-8f96-06346708a8ee.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJLRnkUmWAToYR6VicuvRXsK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_1afce38f-f910-4d13-818f-1c15bf94f161",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "PJ's Coffee",
      "poi_type": "Restaurants",
      "poi_address": "900 N Industrial Blvd, Euless, TX 76039, USA",
      "poi_short_description": "New Orleans-born chain for house-roasted coffee, organic teas, blended drinks & pastries.",
      "poi_long_description": "New Orleans-born chain for house-roasted coffee, organic teas, blended drinks & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-4de1-72a8-bd57-c8e851e8fdba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-4de1-72a8-bd57-c8e851e8fdba",
        "storage_key": "property/5684048244506624/019f150d-4de1-72a8-bd57-c8e851e8fdba.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://locations.pjscoffee.com/tx/euless/coffee-shop-tx0089.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11842609093624571665&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pjs-coffee",
      "poi_latitude": "32.8491181",
      "poi_longitude": "-97.0993522",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 682-503-4163",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150e-16b6-770f-8f96-06346708a8ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-16b6-770f-8f96-06346708a8ee",
        "storage_key": "property/5684048244506624/019f150e-16b6-770f-8f96-06346708a8ee.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJPxzv_ip_ToYREadNzzlmWaQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_bb7acffa-f69d-43d0-88c2-37aad7f6c691",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Raven's Grille",
      "poi_type": "Restaurants",
      "poi_address": "1400 Texas Star Pkwy, Euless, TX 76040, USA",
      "poi_short_description": "Comfortable restaurant at a golf course with chicken-fried steak and catfish, plus a bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-4c09-7296-b9fb-00b1d857cf38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-4c09-7296-b9fb-00b1d857cf38",
        "storage_key": "property/5684048244506624/019f150d-4c09-7296-b9fb-00b1d857cf38.webp",
        "width": 1280,
        "height": 864
      },
      "poi_business_url": "https://www.texasstargolf.com/raven-s-grille",
      "poi_directions_map_url": "https://maps.google.com/?cid=13577626748214199749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ravens-grille",
      "poi_latitude": "32.8183251",
      "poi_longitude": "-97.1142899",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-685-1843",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bd64-761f-98b0-38e7ef2b5971.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bd64-761f-98b0-38e7ef2b5971",
        "storage_key": "property/5684048244506624/019f150a-bd64-761f-98b0-38e7ef2b5971.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJadt7v0d-ToYRxUUmFJdrbbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_719e057a-2019-47a5-8591-25860ea3dc32",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Marina's Restaurant & Club",
      "poi_type": "Restaurants",
      "poi_address": "1509 W Euless Blvd, Euless, TX 76040, USA",
      "poi_short_description": "Lively late-night karaoke destination with a full bar & an American menu of steaks & sandwiches.",
      "poi_long_description": "Lively late-night karaoke destination with a full bar & an American menu of steaks & sandwiches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-51df-711d-97c6-160a933f8118.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-51df-711d-97c6-160a933f8118",
        "storage_key": "property/5684048244506624/019f150d-51df-711d-97c6-160a933f8118.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://marinas.top/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5200774031876315207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marinas-restaurant--club",
      "poi_latitude": "32.8256827",
      "poi_longitude": "-97.107128",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-571-5910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150e-16b8-74dc-a94b-32ce2ec9150f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-16b8-74dc-a94b-32ce2ec9150f",
        "storage_key": "property/5684048244506624/019f150e-16b8-74dc-a94b-32ce2ec9150f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl0v5bTF-ToYRR1gQV23cLEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_0bf4c9d3-b2bc-46dd-8a2a-1c64b4ac0590",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Wok Xpress",
      "poi_type": "Restaurants",
      "poi_address": "314 S Industrial Blvd, Euless, TX 76040, USA",
      "poi_short_description": "Casual, family-friendly eatery cooking Chinese staples from fried rice and dumplings to chicken dishes, served both dine-in and via takeout and delivery.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-5056-73fd-a9b3-6d28d3e0ee4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-5056-73fd-a9b3-6d28d3e0ee4e",
        "storage_key": "property/5684048244506624/019f150d-5056-73fd-a9b3-6d28d3e0ee4e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://wokxpresseuless.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13667096733051069064&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wok-xpress",
      "poi_latitude": "32.8327676",
      "poi_longitude": "-97.1000199",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-545-8283",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bd64-761f-98b0-38e7ef2b5971.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bd64-761f-98b0-38e7ef2b5971",
        "storage_key": "property/5684048244506624/019f150a-bd64-761f-98b0-38e7ef2b5971.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf_L6MtN_ToYRiCJpPBFIq70",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_8cf61372-925d-4aa5-8ebf-0ba7a68f03c5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Don Limon Taqueria",
      "poi_type": "Restaurants",
      "poi_address": "3260 W Euless Blvd, Euless, TX 76040, USA",
      "poi_short_description": "Small Mexican restaurant offering tacos and enchiladas, plus breakfast items.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-53d6-75ba-94db-b4a3ac1bb270.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-53d6-75ba-94db-b4a3ac1bb270",
        "storage_key": "property/5684048244506624/019f150d-53d6-75ba-94db-b4a3ac1bb270.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7200974850945045989&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "don-limon-taqueria",
      "poi_latitude": "32.8159639",
      "poi_longitude": "-97.1374175",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-358-4888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bd64-761f-98b0-38e7ef2b5971.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bd64-761f-98b0-38e7ef2b5971",
        "storage_key": "property/5684048244506624/019f150a-bd64-761f-98b0-38e7ef2b5971.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhatAXPZ-ToYR5dUZe3kA72M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_647c5bb5-48ad-4bf5-a0da-960d80fb6487",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Pockets Restaurant & Sports Bar",
      "poi_type": "Restaurants",
      "poi_address": "210 S Industrial Blvd, Euless, TX 76040, USA",
      "poi_short_description": "American pub grub in a sports-bar setting with multiple pool tables & TVs, poker & happy hours.",
      "poi_long_description": "American pub grub in a sports-bar setting with multiple pool tables & TVs, poker & happy hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-5301-751b-b818-b5ed45e2f729.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-5301-751b-b818-b5ed45e2f729",
        "storage_key": "property/5684048244506624/019f150d-5301-751b-b818-b5ed45e2f729.webp",
        "width": 1000,
        "height": 1280
      },
      "poi_business_url": "http://www.pocketseuless.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17106221008058185153&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pockets-restaurant--sports-bar",
      "poi_latitude": "32.8346475",
      "poi_longitude": "-97.1002768",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-858-0507",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150e-16b8-74dc-a94b-32ce2ec9150f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-16b8-74dc-a94b-32ce2ec9150f",
        "storage_key": "property/5684048244506624/019f150e-16b8-74dc-a94b-32ce2ec9150f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ64G8HNN_ToYRwfWhyl-BZe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_c45ef4e8-d47c-4d86-8609-e2ef5ab67ddb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "1060 N Main St, Euless, TX 76039, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-4ff5-7768-aed9-ecc720286f1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-4ff5-7768-aed9-ecc720286f1e",
        "storage_key": "property/5684048244506624/019f150d-4ff5-7768-aed9-ecc720286f1e.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/euless/euless/035/00451?cid=loc_03500451_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=2955512392450558532&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "32.8510292",
      "poi_longitude": "-97.0806831",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-571-1008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bdae-7191-b692-c5f9e7f22239.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bdae-7191-b692-c5f9e7f22239",
        "storage_key": "property/5684048244506624/019f150a-bdae-7191-b692-c5f9e7f22239.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ50iJCG6AToYRRMpHqdwWBCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5ed57cd3-8c4b-404a-b0fd-daab15cf075f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "1060 N Main St, Euless, TX 76039, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-5105-77c9-8f17-e085b326ba8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-5105-77c9-8f17-e085b326ba8c",
        "storage_key": "property/5684048244506624/019f150d-5105-77c9-8f17-e085b326ba8c.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/euless/euless/035/00451?cid=loc_03500451_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=2955512392450558532&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "32.8510292",
      "poi_longitude": "-97.0806831",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-571-1008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bdae-7191-b692-c5f9e7f22239.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bdae-7191-b692-c5f9e7f22239",
        "storage_key": "property/5684048244506624/019f150a-bdae-7191-b692-c5f9e7f22239.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ50iJCG6AToYRRMpHqdwWBCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d64b70e5-7ae7-4cb5-8468-049d22be411a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Baba's International Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "203 S Ector Dr, Euless, TX 76040, USA",
      "poi_short_description": "Grocery store offering halal products, with reviews mentioning its pizza and produce.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-65bc-7203-b287-12721934842b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-65bc-7203-b287-12721934842b",
        "storage_key": "property/5684048244506624/019f150d-65bc-7203-b287-12721934842b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://babasgrocery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5457749508464538512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "babas-international-market",
      "poi_latitude": "32.8352182",
      "poi_longitude": "-97.0899163",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-554-2048",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bdae-7191-b692-c5f9e7f22239.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bdae-7191-b692-c5f9e7f22239",
        "storage_key": "property/5684048244506624/019f150a-bdae-7191-b692-c5f9e7f22239.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJidFU1deBToYRkHMX9ULSvUs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_681dd397-9a5e-419e-b671-08cf14591d33",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "St Abanoub Food Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "301 W Euless Blvd Ste 103, Euless, TX 76040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-68e5-760a-8415-da08a177481f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-68e5-760a-8415-da08a177481f",
        "storage_key": "property/5684048244506624/019f150d-68e5-760a-8415-da08a177481f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8621550742986641696&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-abanoub-food-mart",
      "poi_latitude": "32.8357",
      "poi_longitude": "-97.0865602",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-883-4542",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bdae-7191-b692-c5f9e7f22239.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bdae-7191-b692-c5f9e7f22239",
        "storage_key": "property/5684048244506624/019f150a-bdae-7191-b692-c5f9e7f22239.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYQCoZtuBToYRIFG5yLjmpXc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_aa3102da-3276-4ebb-9f0c-e21f4258ac88",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Tonie's Beer & Grocery",
      "poi_type": "Shopping & Retail",
      "poi_address": "610 W Euless Blvd, Euless, TX 76040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-61d6-762d-993f-d2e6f6dc7497.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-61d6-762d-993f-d2e6f6dc7497",
        "storage_key": "property/5684048244506624/019f150d-61d6-762d-993f-d2e6f6dc7497.webp",
        "width": 622,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4150446982816843914&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tonies-beer--grocery",
      "poi_latitude": "32.8338843",
      "poi_longitude": "-97.091391",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 682-503-4203",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150e-176e-77e2-9447-3b8962d321a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-176e-77e2-9447-3b8962d321a7",
        "storage_key": "property/5684048244506624/019f150e-176e-77e2-9447-3b8962d321a7.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJa33Twn-AToYRisjjdYpZmTk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_29128b93-7b4d-4afe-a5bf-f032dae2a14e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Euless Food Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "305 W Euless Blvd, Bedford, TX 76022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-6df9-7588-a9e3-101fc6bc43fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-6df9-7588-a9e3-101fc6bc43fd",
        "storage_key": "property/5684048244506624/019f150d-6df9-7588-a9e3-101fc6bc43fd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9442492303017194996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "euless-food-store",
      "poi_latitude": "32.8350562",
      "poi_longitude": "-97.0870505",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-554-2259",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bdae-7191-b692-c5f9e7f22239.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bdae-7191-b692-c5f9e7f22239",
        "storage_key": "property/5684048244506624/019f150a-bdae-7191-b692-c5f9e7f22239.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX0Os132AToYR9DWzm7h4CoM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_007f829d-abec-404a-bd4f-c20afb87bd2d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "QuikTrip",
      "poi_type": "Shopping & Retail",
      "poi_address": "105 Westpark Wy, Euless, TX 76040, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-5d34-70e9-9e2f-c5deb83c3b33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-5d34-70e9-9e2f-c5deb83c3b33",
        "storage_key": "property/5684048244506624/019f150d-5d34-70e9-9e2f-c5deb83c3b33.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/tx/euless/105-westpark-way?utm_source=gmb&utm_medium=yext&y_source=1_MTYwMDQ1NjMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14882620922659918395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "32.8365929",
      "poi_longitude": "-97.1189721",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-358-6921",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150e-16ba-7319-924d-052ddfcd971d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-16ba-7319-924d-052ddfcd971d",
        "storage_key": "property/5684048244506624/019f150e-16ba-7319-924d-052ddfcd971d.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJOab4ALR_ToYRO9LwreCwic4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_6ea7934d-cf60-4725-b2bd-f67b60a9206a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1401 W Glade Rd, Euless, TX 76039, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-6357-767b-aa08-b0e6b80df047.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-6357-767b-aa08-b0e6b80df047",
        "storage_key": "property/5684048244506624/019f150d-6357-767b-aa08-b0e6b80df047.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/euless/1368",
      "poi_directions_map_url": "https://maps.google.com/?cid=368508757745151195&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "32.8805522",
      "poi_longitude": "-97.1051532",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-399-8494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bd72-778b-8bdd-a1d90cd3cd53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bd72-778b-8bdd-a1d90cd3cd53",
        "storage_key": "property/5684048244506624/019f150a-bd72-778b-8bdd-a1d90cd3cd53.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJd8TnaFfVTYYR2ywFQsM0HQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_f8c34804-f1fb-4ff6-87c9-33e3aced033e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Super Value Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "720 N Industrial Blvd, Euless, TX 76039, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-6e00-7027-8bb0-3d099479874e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-6e00-7027-8bb0-3d099479874e",
        "storage_key": "property/5684048244506624/019f150d-6e00-7027-8bb0-3d099479874e.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.supervaluepharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2223680884979552454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "super-value-pharmacy",
      "poi_latitude": "32.8482684",
      "poi_longitude": "-97.0996015",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-283-5308",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150e-1705-76f3-95b4-2f0b9449e873.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1705-76f3-95b4-2f0b9449e873",
        "storage_key": "property/5684048244506624/019f150e-1705-76f3-95b4-2f0b9449e873.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxcM4S9p_ToYRxlAIu_sZ3B4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_5caca7cd-96b2-4a4b-86ba-714e3430e153",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "1000 E Harwood Rd, Euless, TX 76039, USA",
      "poi_short_description": "Petrol station with a convenience store and a grab-and-go eatery offering snacks, hot foods and coffee.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-6e4b-70dd-aa37-a838bf519024.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-6e4b-70dd-aa37-a838bf519024",
        "storage_key": "property/5684048244506624/019f150d-6e4b-70dd-aa37-a838bf519024.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/euless/1000-e-harwood-rd/2741880?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3233326658982424615&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "32.8510452",
      "poi_longitude": "-97.0658157",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-358-4620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150e-176e-77e2-9447-3b8962d321a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-176e-77e2-9447-3b8962d321a7",
        "storage_key": "property/5684048244506624/019f150e-176e-77e2-9447-3b8962d321a7.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ_44VAkSAToYRJ7ByJ3cV3yw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_5f186343-7ca3-45ec-a060-1051e7bb9f9c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Wilshire Elementary",
      "poi_type": "Education",
      "poi_address": "420 Wilshire Dr, Euless, TX 76040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-6697-76dc-a171-8d5fb9382cf9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-6697-76dc-a171-8d5fb9382cf9",
        "storage_key": "property/5684048244506624/019f150d-6697-76dc-a171-8d5fb9382cf9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hebisd.edu/Wilshire",
      "poi_directions_map_url": "https://maps.google.com/?cid=15257606176762564556&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wilshire-elementary",
      "poi_latitude": "32.8322073",
      "poi_longitude": "-97.1095061",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-399-3960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bdc3-714a-a0d2-a15c5987a962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bdc3-714a-a0d2-a15c5987a962",
        "storage_key": "property/5684048244506624/019f150a-bdc3-714a-a0d2-a15c5987a962.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIQAnV8t_ToYRzA-9wPrnvdM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_f756f488-f2e7-4d8d-be6a-07c22c4ef722",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "North Euless Elementary",
      "poi_type": "Education",
      "poi_address": "1101 Denton Dr, Euless, TX 76039, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-6c0c-7577-a760-1583b65a82d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-6c0c-7577-a760-1583b65a82d5",
        "storage_key": "property/5684048244506624/019f150d-6c0c-7577-a760-1583b65a82d5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.hebisd.edu/NorthEuless",
      "poi_directions_map_url": "https://maps.google.com/?cid=6021794414133541355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-euless-elementary",
      "poi_latitude": "32.8527188",
      "poi_longitude": "-97.0884158",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-399-3780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bdc3-714a-a0d2-a15c5987a962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bdc3-714a-a0d2-a15c5987a962",
        "storage_key": "property/5684048244506624/019f150a-bdc3-714a-a0d2-a15c5987a962.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZxs1YHSAToYR63ncZB22kVM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_f1569768-762b-46de-b783-dde087eae85d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Oakwood Terrace Elementary",
      "poi_type": "Education",
      "poi_address": "700 Ranger Dr, Euless, TX 76040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-6819-7178-88d4-7a4639a220a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-6819-7178-88d4-7a4639a220a5",
        "storage_key": "property/5684048244506624/019f150d-6819-7178-88d4-7a4639a220a5.webp",
        "width": 1210,
        "height": 600
      },
      "poi_business_url": "https://www.hebisd.edu/OakwoodTerrace",
      "poi_directions_map_url": "https://maps.google.com/?cid=2694300301433742149&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oakwood-terrace-elementary",
      "poi_latitude": "32.8263678",
      "poi_longitude": "-97.0934152",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-399-3890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bdc3-714a-a0d2-a15c5987a962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bdc3-714a-a0d2-a15c5987a962",
        "storage_key": "property/5684048244506624/019f150a-bdc3-714a-a0d2-a15c5987a962.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQRlJ9yl-ToYRRaMvYdkTZCU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_1cdfd7cb-a9d4-4ad5-b286-f970100e3169",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Euless Junior High School",
      "poi_type": "Education",
      "poi_address": "306 W Airport Fwy, Euless, TX 76039, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-7715-7569-bc9a-0281ce2b3d28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-7715-7569-bc9a-0281ce2b3d28",
        "storage_key": "property/5684048244506624/019f150d-7715-7569-bc9a-0281ce2b3d28.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hebisd.edu/eulessjh",
      "poi_directions_map_url": "https://maps.google.com/?cid=1363717980358083063&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "euless-junior-high-school",
      "poi_latitude": "32.8395513",
      "poi_longitude": "-97.0879999",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-399-3840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bdc3-714a-a0d2-a15c5987a962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bdc3-714a-a0d2-a15c5987a962",
        "storage_key": "property/5684048244506624/019f150a-bdc3-714a-a0d2-a15c5987a962.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfQFGr36AToYR94EOIUfm7BI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_8bb245e1-9d68-45c4-9771-1870af521d0d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Central Junior High",
      "poi_type": "Education",
      "poi_address": "3191 W Pipeline Rd, Euless, TX 76040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-77b1-71f0-9ce8-f12baca793b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-77b1-71f0-9ce8-f12baca793b7",
        "storage_key": "property/5684048244506624/019f150d-77b1-71f0-9ce8-f12baca793b7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hebisd.edu/CentralJH",
      "poi_directions_map_url": "https://maps.google.com/?cid=275913659391756903&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-junior-high",
      "poi_latitude": "32.8209563",
      "poi_longitude": "-97.1385481",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-399-3360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bdc3-714a-a0d2-a15c5987a962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bdc3-714a-a0d2-a15c5987a962",
        "storage_key": "property/5684048244506624/019f150a-bdc3-714a-a0d2-a15c5987a962.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJexQjAPl-ToYRZ0q56AI-1AM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_edaa99b0-bfb2-44e5-b647-ea12fe44ab65",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Trinity High School",
      "poi_type": "Education",
      "poi_address": "500 N Industrial Blvd, Euless, TX 76039, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-782d-7541-be6c-61e74d5f274e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-782d-7541-be6c-61e74d5f274e",
        "storage_key": "property/5684048244506624/019f150d-782d-7541-be6c-61e74d5f274e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hebisd.edu/Trinity",
      "poi_directions_map_url": "https://maps.google.com/?cid=2289191850486804822&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinity-high-school",
      "poi_latitude": "32.84298260000001",
      "poi_longitude": "-97.0973708",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-399-3690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bdc3-714a-a0d2-a15c5987a962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bdc3-714a-a0d2-a15c5987a962",
        "storage_key": "property/5684048244506624/019f150a-bdc3-714a-a0d2-a15c5987a962.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtfgmjtB_ToYRVjH8_tvXxB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_2e2acc4a-1878-487d-aaa0-a5cec12b9fe0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "L.D. Bell High School",
      "poi_type": "Education",
      "poi_address": "1601 Brown Trail, Hurst, TX 76054, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-7bac-73ff-8e93-fa73e4bbcc5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-7bac-73ff-8e93-fa73e4bbcc5b",
        "storage_key": "property/5684048244506624/019f150d-7bac-73ff-8e93-fa73e4bbcc5b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.hebisd.edu/LDBell",
      "poi_directions_map_url": "https://maps.google.com/?cid=4557705008725231755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ld-bell-high-school",
      "poi_latitude": "32.8428726",
      "poi_longitude": "-97.1605018",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-399-3230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bdc3-714a-a0d2-a15c5987a962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bdc3-714a-a0d2-a15c5987a962",
        "storage_key": "property/5684048244506624/019f150a-bdc3-714a-a0d2-a15c5987a962.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDZFtWDx_ToYRiwgWxI44QD8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_72ecb353-0f4a-48d4-976a-ac8ce3a36efb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Lakeside Christian Academy",
      "poi_type": "Education",
      "poi_address": "503 S Main St, Euless, TX 76040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-9316-753b-a6c6-972e226d6738.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-9316-753b-a6c6-972e226d6738",
        "storage_key": "property/5684048244506624/019f150d-9316-753b-a6c6-972e226d6738.webp",
        "width": 1023,
        "height": 1280
      },
      "poi_business_url": "https://www.lakesidechristianacademytx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1307838394314389804&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lakeside-christian-academy",
      "poi_latitude": "32.8310423",
      "poi_longitude": "-97.082081",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-554-2332",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bdc3-714a-a0d2-a15c5987a962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bdc3-714a-a0d2-a15c5987a962",
        "storage_key": "property/5684048244506624/019f150a-bdc3-714a-a0d2-a15c5987a962.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIfzHq9mBToYRLPm5JBdgJhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_9918d25c-cc4b-4965-b766-321079b28ba3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Tree Leaf Kids",
      "poi_type": "Education",
      "poi_address": "1300 W Euless Blvd, Euless, TX 76040, USA",
      "poi_short_description": "Care, learning and fun for little ones in a nurturing environment that specializes in preschool prep.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-8246-769b-9690-f4b2177cbf45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-8246-769b-9690-f4b2177cbf45",
        "storage_key": "property/5684048244506624/019f150d-8246-769b-9690-f4b2177cbf45.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://treeleafkids.weebly.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11925600841909891542&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tree-leaf-kids",
      "poi_latitude": "32.8273612",
      "poi_longitude": "-97.1050673",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-508-0018",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bdc3-714a-a0d2-a15c5987a962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bdc3-714a-a0d2-a15c5987a962",
        "storage_key": "property/5684048244506624/019f150a-bdc3-714a-a0d2-a15c5987a962.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx_4tSDMrTIYR1nEj-8c-gKU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_f0f09f75-d0e4-487c-a35c-af1351674465",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Cinépolis Luxury Cinemas Euless",
      "poi_type": "Entertainment",
      "poi_address": "2601 Brazos Blvd, Euless, TX 76039, USA",
      "poi_short_description": "Movie theater chain, offering state-of-the-art sound & projection technology.",
      "poi_long_description": "Movie theater chain, offering state-of-the-art sound & projection technology.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-8056-7790-8da0-8b925f9760b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-8056-7790-8da0-8b925f9760b1",
        "storage_key": "property/5684048244506624/019f150d-8056-7790-8da0-8b925f9760b1.webp",
        "width": 900,
        "height": 600
      },
      "poi_business_url": "https://www.cinepolisusa.com/euless/theater-details",
      "poi_directions_map_url": "https://maps.google.com/?cid=12053810578068517441&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinpolis-luxury-cinemas-euless",
      "poi_latitude": "32.8748271",
      "poi_longitude": "-97.1047856",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-508-4927",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150e-176d-71d4-b860-02abba4d46eb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-176d-71d4-b860-02abba4d46eb",
        "storage_key": "property/5684048244506624/019f150e-176d-71d4-b860-02abba4d46eb.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5WV2dVjVTYYRQbKeX9u8R6c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_f9f7710a-b230-4b4e-86f5-6564739bb033",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Lucky Strike Euless",
      "poi_type": "Entertainment",
      "poi_address": "1901 W Airport Fwy, Euless, TX 76040, USA",
      "poi_short_description": "Long-standing chain of bowling alleys featuring casual grub & pitchers, leagues & party events.",
      "poi_long_description": "Long-standing chain of bowling alleys featuring casual grub & pitchers, leagues & party events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-8cd3-70de-ae1e-dd2003c5ab77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-8cd3-70de-ae1e-dd2003c5ab77",
        "storage_key": "property/5684048244506624/019f150d-8cd3-70de-ae1e-dd2003c5ab77.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.luckystrikeent.com/location/lucky-strike-euless?utm_source=gbp&utm_medium=organic&utm_campaign=yext_listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=8392349815321083189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucky-strike-euless",
      "poi_latitude": "32.8366102",
      "poi_longitude": "-97.1131747",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-540-0303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be22-71a7-8bf6-c8a6c16677ff",
        "storage_key": "property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL94wEcp_ToYRNT0HRbGdd3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_4de2a275-ccaf-4cfd-8f5d-cac6eb270d5c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Texas Star Golf Course",
      "poi_type": "Entertainment",
      "poi_address": "1400 Texas Star Pkwy, Euless, TX 76040, USA",
      "poi_short_description": "Natural 18-hole golf course on 275-acres with a terrace grill restaurant & conference center.",
      "poi_long_description": "Natural 18-hole golf course on 275-acres with a terrace grill restaurant & conference center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-97b2-722e-8c03-a1a399f4ebe9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-97b2-722e-8c03-a1a399f4ebe9",
        "storage_key": "property/5684048244506624/019f150d-97b2-722e-8c03-a1a399f4ebe9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.texasstargolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8009833554217108520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-star-golf-course",
      "poi_latitude": "32.8184952",
      "poi_longitude": "-97.11426",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-685-7888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be0a-70a4-9e4d-8b0277f67530.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be0a-70a4-9e4d-8b0277f67530",
        "storage_key": "property/5684048244506624/019f150a-be0a-70a4-9e4d-8b0277f67530.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJadt7v0d-ToYRKIQd_S2lKG8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_be756b81-6b29-4be9-8f0a-910f30bc7d8c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Round1 Bowling & Arcade - Grapevine",
      "poi_type": "Entertainment",
      "poi_address": "3000 Grapevine Mills Pkwy, Grapevine, TX 76051, USA",
      "poi_short_description": "Chain spot featuring bowling, arcade games (including Japan imports), karaoke and a cafe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-a9b0-761f-833f-306631ff95c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-a9b0-761f-833f-306631ff95c1",
        "storage_key": "property/5684048244506624/019f150d-a9b0-761f-833f-306631ff95c1.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://round1usa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11587748635949210765&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "round1-bowling--arcade---grapevine",
      "poi_latitude": "32.9637845",
      "poi_longitude": "-97.0445353",
      "poi_miles_from_property": "11.9",
      "poi_walking_minutes": "4 hours 27 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 817-873-7981",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be22-71a7-8bf6-c8a6c16677ff",
        "storage_key": "property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkdiQkoYrTIYRjRxFaP3zz6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_ca5baee4-d373-4182-94f9-6ccaae9b7be3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "LEGOLAND® Discovery Center Dallas/Fort Worth",
      "poi_type": "Entertainment",
      "poi_address": "3000 Grapevine Mills Pkwy, Grapevine, TX 76051, USA",
      "poi_short_description": "Family entertainment center featuring Lego toy displays, rides & 4D films, plus gift shop.",
      "poi_long_description": "Family entertainment center featuring Lego toy displays, rides & 4D films, plus gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-88d7-7498-bbc9-376267e062c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-88d7-7498-bbc9-376267e062c0",
        "storage_key": "property/5684048244506624/019f150d-88d7-7498-bbc9-376267e062c0.webp",
        "width": 701,
        "height": 467
      },
      "poi_business_url": "https://www.legolanddiscoverycenter.com/dallas-fw/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=8213318445731368129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legoland-discovery-center-dallasfort-worth",
      "poi_latitude": "32.9666453",
      "poi_longitude": "-97.0434661",
      "poi_miles_from_property": "12.2",
      "poi_walking_minutes": "4 hours 32 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 469-444-3050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be22-71a7-8bf6-c8a6c16677ff",
        "storage_key": "property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwU71w4YrTIYRwUz7QJyR-3E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_310a098d-0c59-44c0-b5f7-1d5e25817fd7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "SEA LIFE Grapevine Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "Grapevine Mills, 3000 Grapevine Mills Pkwy, Grapevine, TX 76051, USA",
      "poi_short_description": "Family-friendly exhibits with a variety of sea creatures (most offer play areas & group packages).",
      "poi_long_description": "Family-friendly exhibits with a variety of sea creatures (most offer play areas & group packages).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-8c70-7066-9f71-dbfa1ceb6a53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-8c70-7066-9f71-dbfa1ceb6a53",
        "storage_key": "property/5684048244506624/019f150d-8c70-7066-9f71-dbfa1ceb6a53.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.visitsealife.com/grapevine/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=432349789120866841&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sea-life-grapevine-aquarium",
      "poi_latitude": "32.9662578",
      "poi_longitude": "-97.0438015",
      "poi_miles_from_property": "12.1",
      "poi_walking_minutes": "4 hours 31 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 469-444-3050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be22-71a7-8bf6-c8a6c16677ff",
        "storage_key": "property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV-3It4YrTIYRGapDr9cDAAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_055f31fd-7b72-4916-b595-7446f26eac2c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Great Wolf Lodge | Grapevine",
      "poi_type": "Entertainment",
      "poi_address": "100 Great Wolf Dr, Grapevine, TX 76051, USA",
      "poi_short_description": "Cozy suites in a lively property offering kids' entertainment, dining & an indoor water park.",
      "poi_long_description": "Cozy suites in a lively property offering kids' entertainment, dining & an indoor water park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-a30b-77b9-8b76-0fe8da300065.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-a30b-77b9-8b76-0fe8da300065",
        "storage_key": "property/5684048244506624/019f150d-a30b-77b9-8b76-0fe8da300065.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.greatwolf.com/grapevine?utm_source=google&utm_medium=organic&utm_campaign=gmb-grapevine",
      "poi_directions_map_url": "https://maps.google.com/?cid=4405555011302861324&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "great-wolf-lodge--grapevine",
      "poi_latitude": "32.9419978",
      "poi_longitude": "-97.059787",
      "poi_miles_from_property": "10.6",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 800-693-9653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150e-177b-71fd-9aee-d7a79e31c11a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-177b-71fd-9aee-d7a79e31c11a",
        "storage_key": "property/5684048244506624/019f150e-177b-71fd-9aee-d7a79e31c11a.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJrTYNkQ0rTIYRDCom7_CsIz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "resort_hotel"
    },
    {
      "id": "custom_dc2450dd-eee6-433e-8330-d3b7683a0de8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Palace Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "300 S Main St, Grapevine, TX 76051, USA",
      "poi_short_description": "Restored 1940s-era theater featuring weekly classic movies in spacious surrounds.",
      "poi_long_description": "Restored 1940s-era theater featuring weekly classic movies in spacious surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-8cc7-76cc-8e31-ed79a0c8f6ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-8cc7-76cc-8e31-ed79a0c8f6ac",
        "storage_key": "property/5684048244506624/019f150d-8cc7-76cc-8e31-ed79a0c8f6ac.webp",
        "width": 1250,
        "height": 832
      },
      "poi_business_url": "http://www.palace-theatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=760093712415309344&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "palace-arts-center",
      "poi_latitude": "32.9389638",
      "poi_longitude": "-97.0785253",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 817-410-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be22-71a7-8bf6-c8a6c16677ff",
        "storage_key": "property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV4swuDsrTIYRIL6FTDRljAo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_fd5f5ffe-915d-47b8-8a50-d00b7bf4e422",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Esports Stadium Arlington",
      "poi_type": "Entertainment",
      "poi_address": "1200 Ballpark Way, Arlington, TX 76011, USA",
      "poi_short_description": "Contemporary venue featuring extensive facilities for conventions, meetings & trade shows.",
      "poi_long_description": "Contemporary venue featuring extensive facilities for conventions, meetings & trade shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-9e55-743d-a1a2-9de096565612.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-9e55-743d-a1a2-9de096565612",
        "storage_key": "property/5684048244506624/019f150d-9e55-743d-a1a2-9de096565612.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.arlingtonexpocenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1224943245628603615&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "esports-stadium-arlington",
      "poi_latitude": "32.7552952",
      "poi_longitude": "-97.0818552",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 817-459-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be22-71a7-8bf6-c8a6c16677ff",
        "storage_key": "property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFQ_h42SHToYR3_y0UWTf_xA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_82593e02-f49e-42d5-a76d-46795c831dad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Texas Health Harris Methodist Hurst-Euless-Bedford",
      "poi_type": "Health and Wellness",
      "poi_address": "1600 Hospital Pkwy, Bedford, TX 76022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-9751-7544-b638-891956542244.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-9751-7544-b638-891956542244",
        "storage_key": "property/5684048244506624/019f150d-9751-7544-b638-891956542244.webp",
        "width": 1279,
        "height": 719
      },
      "poi_business_url": "https://www.texashealth.org/locations/texas-health-heb",
      "poi_directions_map_url": "https://maps.google.com/?cid=8046041147271700356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-health-harris-methodist-hurst-euless-bedford",
      "poi_latitude": "32.8349711",
      "poi_longitude": "-97.1244698",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-848-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bdc1-76c7-8a75-f432aaa5bd0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bdc1-76c7-8a75-f432aaa5bd0e",
        "storage_key": "property/5684048244506624/019f150a-bdc1-76c7-8a75-f432aaa5bd0e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJw-xkb7J_ToYRhF9OL8tHqW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_41278ca3-65e6-47e6-8a5c-4f9a6978f86e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "SwiftCare Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "1201 N Main St Ste. 600, Euless, TX 76039, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-9ceb-726f-bd1f-035a0fbcf4b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-9ceb-726f-bd1f-035a0fbcf4b9",
        "storage_key": "property/5684048244506624/019f150d-9ceb-726f-bd1f-035a0fbcf4b9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.myswiftcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=777916436959333861&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "swiftcare-urgent-care",
      "poi_latitude": "32.8536362",
      "poi_longitude": "-97.0829157",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 682-738-3460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be22-71a7-8bf6-c8a6c16677ff",
        "storage_key": "property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcwiwiXKAToYR5Q3mueC2ywo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_08ec72d5-99dd-4c83-bd70-0ed269e5614c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "SwiftCare Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "1201 N Main St Ste. 600, Euless, TX 76039, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-9cdf-74dc-a3a4-8288669b7252.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-9cdf-74dc-a3a4-8288669b7252",
        "storage_key": "property/5684048244506624/019f150d-9cdf-74dc-a3a4-8288669b7252.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.myswiftcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=777916436959333861&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "swiftcare-urgent-care",
      "poi_latitude": "32.8536362",
      "poi_longitude": "-97.0829157",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 682-738-3460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be22-71a7-8bf6-c8a6c16677ff",
        "storage_key": "property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcwiwiXKAToYR5Q3mueC2ywo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_a2d46f00-1809-4042-bb04-3c5eac819743",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1401 W Glade Rd, Euless, TX 76039, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-a56e-74a9-8174-70b2d33aa4f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-a56e-74a9-8174-70b2d33aa4f6",
        "storage_key": "property/5684048244506624/019f150d-a56e-74a9-8174-70b2d33aa4f6.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/euless-tx-pharmacies/1401-w-glade-rd-euless-tx-76039/storeid=16707?WT.mc_id=LS_GOOGLE_RX_16707",
      "poi_directions_map_url": "https://maps.google.com/?cid=6880979996013605277&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "32.8805522",
      "poi_longitude": "-97.1051532",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 817-399-8486",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150e-1705-76f3-95b4-2f0b9449e873.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1705-76f3-95b4-2f0b9449e873",
        "storage_key": "property/5684048244506624/019f150e-1705-76f3-95b4-2f0b9449e873.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd8TnaFfVTYYRnbH1cNkmfl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_9a1b3f12-aac6-49df-807f-21941aba6318",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "780 W Bedford Euless Rd, Hurst, TX 76053, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-a8a5-734a-8763-992d667daa31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-a8a5-734a-8763-992d667daa31",
        "storage_key": "property/5684048244506624/019f150d-a8a5-734a-8763-992d667daa31.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-780+w+bedford+euless+rd-hurst-tx-76053/id=4132",
      "poi_directions_map_url": "https://maps.google.com/?cid=16643296477310661574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "32.8345404",
      "poi_longitude": "-97.1854117",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-282-0308",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150e-1705-76f3-95b4-2f0b9449e873.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-1705-76f3-95b4-2f0b9449e873",
        "storage_key": "property/5684048244506624/019f150e-1705-76f3-95b4-2f0b9449e873.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHYZMIap5ToYRxrOcVffd-OY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_75e818ec-3386-4534-ab77-8cd2ea4fd476",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1200 N Main St Ste 100, Euless, TX 76039, USA",
      "poi_short_description": "Chain gym offering massage chairs and tanning, plus a clean environment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-4615-762d-b7d2-b7d54d050867.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150a-4615-762d-b7d2-b7d54d050867",
        "storage_key": "property/5684048244506624/019f150a-4615-762d-b7d2-b7d54d050867.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/euless-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=9482869422447855591&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.8533561",
      "poi_longitude": "-97.0819244",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 214-919-5462",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be22-71a7-8bf6-c8a6c16677ff",
        "storage_key": "property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOSHdeQ-BToYR5wdrUH_rmYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b4001795-8b58-4b1c-93ef-2e2454670d07",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Euless Family Life Center",
      "poi_type": "Health and Wellness",
      "poi_address": "300 W Midway Dr, Euless, TX 76039, USA",
      "poi_short_description": "Clean rec center with basketball facilities, plus a gym and a water park.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-c2dd-7388-b489-7236aa264a86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-c2dd-7388-b489-7236aa264a86",
        "storage_key": "property/5684048244506624/019f150d-c2dd-7388-b489-7236aa264a86.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.eulesstx.gov/departments/parks-and-community-services/euless-family-life-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=17823765116290050229&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "euless-family-life-center",
      "poi_latitude": "32.8449689",
      "poi_longitude": "-97.0856521",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-685-1666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be22-71a7-8bf6-c8a6c16677ff",
        "storage_key": "property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD65KhHCAToYRtah3XPC7Wvc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_1e2ca1fd-294e-40f7-a4f2-a52e9d63db8f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Seastrunk Chiropractic",
      "poi_type": "Health and Wellness",
      "poi_address": "503 W Euless Blvd, Euless, TX 76040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-b961-77f8-b528-0871f1df980e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-b961-77f8-b528-0871f1df980e",
        "storage_key": "property/5684048244506624/019f150d-b961-77f8-b528-0871f1df980e.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.seastrunkchiropractic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13959486983298948639&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seastrunk-chiropractic",
      "poi_latitude": "32.8340013",
      "poi_longitude": "-97.0895506",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-267-8850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be22-71a7-8bf6-c8a6c16677ff",
        "storage_key": "property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj-2WMH6AToYRHx45ZnMPusE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chiropractor"
    },
    {
      "id": "custom_69d23922-1b98-4aa1-8d3f-4cb5d6ad73fd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Texas Health Springwood Behavioral Health Hospital HEB",
      "poi_type": "Health and Wellness",
      "poi_address": "2717 Tibbets Dr, Bedford, TX 76022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-afea-70d3-966c-a74603f2d4b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-afea-70d3-966c-a74603f2d4b9",
        "storage_key": "property/5684048244506624/019f150d-afea-70d3-966c-a74603f2d4b9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texashealth.org/Locations/texas-health-heb/THBHHEB",
      "poi_directions_map_url": "https://maps.google.com/?cid=4438936182469010262&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-health-springwood-behavioral-health-hospital-heb",
      "poi_latitude": "32.8346054",
      "poi_longitude": "-97.122411",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 682-236-6023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be22-71a7-8bf6-c8a6c16677ff",
        "storage_key": "property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjcYwh61_ToYRVqOxgPBEmj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_4f0e022b-2a76-48b0-a77c-ffdae35837fa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2401 Rio Grande Blvd, Euless, TX 76039, USA",
      "poi_short_description": "Clean, casual gym with personal trainers, a swimming pool, a sauna and a hot tub.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-41e1-710f-971a-bae92b8d6333.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150a-41e1-710f-971a-bae92b8d6333",
        "storage_key": "property/5684048244506624/019f150a-41e1-710f-971a-bae92b8d6333.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://eosfitness.com/gym/euless-rio-grande-blvd-goodnight-trail/?utm_source=local&utm_medium=organic&utm_campaign=evergreen_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=5660837130012261430&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "32.8714212",
      "poi_longitude": "-97.1038919",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 682-353-0257",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be22-71a7-8bf6-c8a6c16677ff",
        "storage_key": "property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuzlE6T5_ToYRNvy4mWBVj04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8b7f404a-bf74-43a9-ad0a-f7acd92ab10d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "West Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "600 Westpark Wy, Euless, TX 76040, USA",
      "poi_short_description": "Relaxed park featuring a playground, BBQs and baseball grounds (2 fields), in addition to picnic tables.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-c519-74af-afcc-0f7fc6933811.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-c519-74af-afcc-0f7fc6933811",
        "storage_key": "property/5684048244506624/019f150d-c519-74af-afcc-0f7fc6933811.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.eulesstx.gov/departments/parks-and-community-services/parks/west-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14460427940357859728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-park",
      "poi_latitude": "32.8277678",
      "poi_longitude": "-97.1227175",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-685-1650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be16-752f-a740-fb941e31b952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be16-752f-a740-fb941e31b952",
        "storage_key": "property/5684048244506624/019f150a-be16-752f-a740-fb941e31b952.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8ynbDk1-ToYRkOkp3ZjCrcg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3c12377e-2c79-4d1a-95ea-23800365d33b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Heritage Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "201 Cullum Dr, Euless, TX 76040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1638568792713419795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heritage-park",
      "poi_latitude": "32.8354076",
      "poi_longitude": "-97.0786491",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be16-752f-a740-fb941e31b952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be16-752f-a740-fb941e31b952",
        "storage_key": "property/5684048244506624/019f150a-be16-752f-a740-fb941e31b952.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWW1C_TKBToYRE1y5raJdvRY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b2712f8e-606e-4f31-ad35-e0afee8a4c0e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Villages of Bear Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1951 Bear Creek Pkwy, Euless, TX 76039, USA",
      "poi_short_description": "Large recreation area featuring trails for walking and picnics as well as areas for dogs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-d19e-769a-87db-46424936c0b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-d19e-769a-87db-46424936c0b5",
        "storage_key": "property/5684048244506624/019f150d-d19e-769a-87db-46424936c0b5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.eulesstx.gov/departments/parks-and-community-services/parks/villages-of-bear-creek",
      "poi_directions_map_url": "https://maps.google.com/?cid=2217773905395218740&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "villages-of-bear-creek-park",
      "poi_latitude": "32.8634466",
      "poi_longitude": "-97.0694451",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-685-1429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be16-752f-a740-fb941e31b952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be16-752f-a740-fb941e31b952",
        "storage_key": "property/5684048244506624/019f150a-be16-752f-a740-fb941e31b952.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJbXZKqD2AToYRNHk2350dxx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_9dc94194-bb13-4952-9585-095200202535",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "The Preserve at McCormick Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2005 Fuller Wiser Rd, Euless, TX 76039, USA",
      "poi_short_description": "12-acre park featuring a 1/3-mile walking & biking path, picnic tables, a gazebo & play equipment.",
      "poi_long_description": "12-acre park featuring a 1/3-mile walking & biking path, picnic tables, a gazebo & play equipment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-c7bc-7318-9bca-009b8d1466aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-c7bc-7318-9bca-009b8d1466aa",
        "storage_key": "property/5684048244506624/019f150d-c7bc-7318-9bca-009b8d1466aa.webp",
        "width": 1280,
        "height": 725
      },
      "poi_business_url": "https://www.eulesstx.gov/departments/parks-and-community-services/parks/preserve-at-mccormick-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=3304932658541014972&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-preserve-at-mccormick-park",
      "poi_latitude": "32.8658692",
      "poi_longitude": "-97.0740824",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-685-1429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be16-752f-a740-fb941e31b952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be16-752f-a740-fb941e31b952",
        "storage_key": "property/5684048244506624/019f150a-be16-752f-a740-fb941e31b952.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJx_OyKhGAToYRvK_sHr563S0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_da16f2b3-9147-4866-bd9c-d8371dd2f493",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Little Bear Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13 Bear Creek Pkwy, Euless, TX 76039, USA",
      "poi_short_description": "Paved and gravel paths winding through trees and wildflowers, with playgrounds.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-d712-725a-9885-61713f9a4c18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-d712-725a-9885-61713f9a4c18",
        "storage_key": "property/5684048244506624/019f150d-d712-725a-9885-61713f9a4c18.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6505090987039768273&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-bear-creek-park",
      "poi_latitude": "32.8619789",
      "poi_longitude": "-97.0674045",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 469-492-0636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be16-752f-a740-fb941e31b952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be16-752f-a740-fb941e31b952",
        "storage_key": "property/5684048244506624/019f150a-be16-752f-a740-fb941e31b952.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJuZ403Z6BToYR0b4Zism5Rlo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_c9ead93d-6d1e-4a5a-88c0-0396a6241255",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "The Preserve at McCormick Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2005 Fuller Wiser Rd, Euless, TX 76039, USA",
      "poi_short_description": "12-acre park featuring a 1/3-mile walking & biking path, picnic tables, a gazebo & play equipment.",
      "poi_long_description": "12-acre park featuring a 1/3-mile walking & biking path, picnic tables, a gazebo & play equipment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-d140-74e3-9d37-9926233fa68e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-d140-74e3-9d37-9926233fa68e",
        "storage_key": "property/5684048244506624/019f150d-d140-74e3-9d37-9926233fa68e.webp",
        "width": 1280,
        "height": 725
      },
      "poi_business_url": "https://www.eulesstx.gov/departments/parks-and-community-services/parks/preserve-at-mccormick-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=3304932658541014972&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-preserve-at-mccormick-park",
      "poi_latitude": "32.8658692",
      "poi_longitude": "-97.0740824",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-685-1429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be16-752f-a740-fb941e31b952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be16-752f-a740-fb941e31b952",
        "storage_key": "property/5684048244506624/019f150a-be16-752f-a740-fb941e31b952.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJx_OyKhGAToYRvK_sHr563S0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a1616cd5-ab75-4b46-bcda-3b88a8bee79d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Trailwood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1801-1855 Trailwood Dr, Euless, TX 76039, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-ce7f-73ca-9c5c-89832b82e237.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-ce7f-73ca-9c5c-89832b82e237",
        "storage_key": "property/5684048244506624/019f150d-ce7f-73ca-9c5c-89832b82e237.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.eulesstx.gov/departments/parks-and-community-services/parks/trailwood-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10636734728352863004&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trailwood-park",
      "poi_latitude": "32.8657653",
      "poi_longitude": "-97.089013",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 817-685-1429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be16-752f-a740-fb941e31b952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be16-752f-a740-fb941e31b952",
        "storage_key": "property/5684048244506624/019f150a-be16-752f-a740-fb941e31b952.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHztLlAiAToYRHJOILeFFnZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d17fc05a-2463-4aae-970b-31e7bbffc87a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Wilshire Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "315 Sierra Dr, Euless, TX 76040, USA",
      "poi_short_description": "Charming park for fishing and walking, with a pond, swings and a fishing dock.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-c953-7104-bf96-c4dd52ae4fcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-c953-7104-bf96-c4dd52ae4fcc",
        "storage_key": "property/5684048244506624/019f150d-c953-7104-bf96-c4dd52ae4fcc.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.eulesstx.gov/departments/parks-and-community-services/parks/wilshire-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16529763603182900350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wilshire-park",
      "poi_latitude": "32.8344142",
      "poi_longitude": "-97.1110779",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 817-685-1429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be16-752f-a740-fb941e31b952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be16-752f-a740-fb941e31b952",
        "storage_key": "property/5684048244506624/019f150a-be16-752f-a740-fb941e31b952.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYRs7Dst_ToYRftTlLGuEZeU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_55bf41fd-4f02-4655-9fe8-49c49c289b1f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "J.A. Carr Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "508 Simmons Dr, Euless, TX 76040, USA",
      "poi_short_description": "Quaint 5-acre space with trails for walkers & joggers, a volleyball court, a gazebo & a rose garden.",
      "poi_long_description": "Quaint 5-acre space with trails for walkers & joggers, a volleyball court, a gazebo & a rose garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-cec6-7188-96a8-b54a828f709d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-cec6-7188-96a8-b54a828f709d",
        "storage_key": "property/5684048244506624/019f150d-cec6-7188-96a8-b54a828f709d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.eulesstx.gov/departments/parks-and-community-services/parks/j-a-carr-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14213791839148660444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ja-carr-park",
      "poi_latitude": "32.831139",
      "poi_longitude": "-97.0927814",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 817-685-1429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be16-752f-a740-fb941e31b952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be16-752f-a740-fb941e31b952",
        "storage_key": "property/5684048244506624/019f150a-be16-752f-a740-fb941e31b952.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-x7_JoCAToYR3FbNq16IQcU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_82438bd9-81b4-47c2-b049-fa41763b0aaf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Bob Eden Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "901 W Mid Cities Blvd, Euless, TX 76039, USA",
      "poi_short_description": "Tree-filled park with a playground, picnic areas & fields for soccer & softball.",
      "poi_long_description": "Tree-filled park with a playground, picnic areas & fields for soccer & softball.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-e58a-73c9-a8d9-255c8120db55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-e58a-73c9-a8d9-255c8120db55",
        "storage_key": "property/5684048244506624/019f150d-e58a-73c9-a8d9-255c8120db55.webp",
        "width": 1280,
        "height": 815
      },
      "poi_business_url": "https://www.eulesstx.gov/departments/parks-and-community-services/parks/bob-eden-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2540054795505882844&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bob-eden-park",
      "poi_latitude": "32.866126",
      "poi_longitude": "-97.0976852",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 817-685-1650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be16-752f-a740-fb941e31b952.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be16-752f-a740-fb941e31b952",
        "storage_key": "property/5684048244506624/019f150a-be16-752f-a740-fb941e31b952.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAVG-0AeAToYR3NYn9GAWQCM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f2133594-969e-4485-867b-008abc82cf1b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Dallas Fort Worth International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2400 Aviation Dr, DFW Airport, TX 75261, USA",
      "poi_short_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_long_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-90e5-7111-9fea-71dfc7183e94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150a-90e5-7111-9fea-71dfc7183e94",
        "storage_key": "property/5684048244506624/019f150a-90e5-7111-9fea-71dfc7183e94.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dfwairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8300766736265584668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-fort-worth-international-airport",
      "poi_latitude": "32.8921983",
      "poi_longitude": "-97.0391232",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 972-973-3112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be15-7184-86d5-70742d31faa0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be15-7184-86d5-70742d31faa0",
        "storage_key": "property/5684048244506624/019f150a-be15-7184-86d5-70742d31faa0.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpyoiDWYqTIYRHCB9Bl4_MnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_714e1129-9227-4795-9f72-686c6bf885bc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "CentrePort/DFW Airport Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "14470 Statler Blvd, Fort Worth, TX 76155, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-f698-777c-b73e-a4ea534511cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-f698-777c-b73e-a4ea534511cf",
        "storage_key": "property/5684048244506624/019f150d-f698-777c-b73e-a4ea534511cf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dart.org/guide/transit-and-use/rail/rail-station-detail/centreport-dfw-airport-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=1619245285415004907&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "centreportdfw-airport-station",
      "poi_latitude": "32.8170102",
      "poi_longitude": "-97.0528488",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 214-979-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150e-16c7-760a-b7b8-7a7bde41647e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150e-16c7-760a-b7b8-7a7bde41647e",
        "storage_key": "property/5684048244506624/019f150e-16c7-760a-b7b8-7a7bde41647e.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJN7AqJ-KAToYR6ypjCQK3eBY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_8ecab995-310e-4d63-9ece-85c24115beaa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Bell",
      "poi_type": "Transportation & Transit",
      "poi_address": "3232 Bell Flight Blvd, Hurst, TX 76053, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-93ec-755f-aa4e-761ec5ee7e8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150a-93ec-755f-aa4e-761ec5ee7e8f",
        "storage_key": "property/5684048244506624/019f150a-93ec-755f-aa4e-761ec5ee7e8f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://trinityrailwayexpress.org/station/bell-station/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11367673502258708933&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bell",
      "poi_latitude": "32.8046324",
      "poi_longitude": "-97.1551139",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-c030-71e7-989c-49725d01ef8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-c030-71e7-989c-49725d01ef8c",
        "storage_key": "property/5684048244506624/019f150a-c030-71e7-989c-49725d01ef8c.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJmSKsN5V-ToYRxUHAYNIWwp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_e6b3944a-5dc7-4c24-b573-2549fdfd012a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Trinity Lakes Train station",
      "poi_type": "Transportation & Transit",
      "poi_address": "7979 Trinity Blvd, Fort Worth, TX 76118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-f441-72dc-b9cd-02f8ddc13d00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-f441-72dc-b9cd-02f8ddc13d00",
        "storage_key": "property/5684048244506624/019f150d-f441-72dc-b9cd-02f8ddc13d00.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8694575473327337763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinity-lakes-train-station",
      "poi_latitude": "32.7997663",
      "poi_longitude": "-97.2102321",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be22-71a7-8bf6-c8a6c16677ff",
        "storage_key": "property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ72L5LAB5ToYRI_F_wFNWqXg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_7f0bea7f-d5f5-4937-9bd5-dca5e17362b6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Trinity Lakes Train station",
      "poi_type": "Transportation & Transit",
      "poi_address": "7979 Trinity Blvd, Fort Worth, TX 76118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-f711-739e-b359-42cccbcba526.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-f711-739e-b359-42cccbcba526",
        "storage_key": "property/5684048244506624/019f150d-f711-739e-b359-42cccbcba526.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8694575473327337763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinity-lakes-train-station",
      "poi_latitude": "32.7997663",
      "poi_longitude": "-97.2102321",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be22-71a7-8bf6-c8a6c16677ff",
        "storage_key": "property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ72L5LAB5ToYRI_F_wFNWqXg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_1519e27a-0c54-49dd-9e0f-e5428f8c5631",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "DFW Airport North TEXRail Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1867 E Dallas Rd, Grapevine, TX 76051, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-f2f0-734d-b687-8841b16d8b31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-f2f0-734d-b687-8841b16d8b31",
        "storage_key": "property/5684048244506624/019f150d-f2f0-734d-b687-8841b16d8b31.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ridetrinitymetro.org/stations/dfw-airport-north-station/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6621859291758648515&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dfw-airport-north-texrail-station",
      "poi_latitude": "32.9337128",
      "poi_longitude": "-97.0541165",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be22-71a7-8bf6-c8a6c16677ff",
        "storage_key": "property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOV8hQtwrTIYRw9zkFfGR5Vs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_88bddf03-68a4-4dfb-9b49-6ce45ba3a017",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Grapevine/Main Street Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "801 S Main St, Grapevine, TX 76051, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-fcda-709b-b2bd-b2d99187c998.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-fcda-709b-b2bd-b2d99187c998",
        "storage_key": "property/5684048244506624/019f150d-fcda-709b-b2bd-b2d99187c998.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ridetrinitymetro.org/texrail/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18405502107178557258&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grapevinemain-street-station",
      "poi_latitude": "32.9338028",
      "poi_longitude": "-97.0772663",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be22-71a7-8bf6-c8a6c16677ff",
        "storage_key": "property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEz-M8e0rTIYRSt8UY6Z6bf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_71a9641f-b48a-437b-bda7-50b42fc6873c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Grapevine Mills",
      "poi_type": "Transportation & Transit",
      "poi_address": "3000 Grapevine Mills Pkwy, Grapevine, TX 76051, USA",
      "poi_short_description": "Large mall with outlet stores from major brands, plus a food court, a multiplex & kids' activities.",
      "poi_long_description": "Large mall with outlet stores from major brands, plus a food court, a multiplex & kids' activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-f467-71b5-a751-8d63c71a0f4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-f467-71b5-a751-8d63c71a0f4d",
        "storage_key": "property/5684048244506624/019f150d-f467-71b5-a751-8d63c71a0f4d.webp",
        "width": 1000,
        "height": 654
      },
      "poi_business_url": "https://www.simon.com/mall/grapevine-mills",
      "poi_directions_map_url": "https://maps.google.com/?cid=15224033266827142940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grapevine-mills",
      "poi_latitude": "32.965993",
      "poi_longitude": "-97.0427604",
      "poi_miles_from_property": "12.1",
      "poi_walking_minutes": "4 hours 30 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 972-724-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bd72-778b-8bdd-a1d90cd3cd53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bd72-778b-8bdd-a1d90cd3cd53",
        "storage_key": "property/5684048244506624/019f150a-bd72-778b-8bdd-a1d90cd3cd53.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJFYwx7YYrTIYRHCf2hZihRtM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_af5857fa-c232-475f-80c1-18a983db2cea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Dallas Fort Worth International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2400 Aviation Dr, DFW Airport, TX 75261, USA",
      "poi_short_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_long_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-90e5-7111-9fea-71dfc7183e94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150a-90e5-7111-9fea-71dfc7183e94",
        "storage_key": "property/5684048244506624/019f150a-90e5-7111-9fea-71dfc7183e94.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dfwairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8300766736265584668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-fort-worth-international-airport",
      "poi_latitude": "32.8921983",
      "poi_longitude": "-97.0391232",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 972-973-3112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be15-7184-86d5-70742d31faa0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be15-7184-86d5-70742d31faa0",
        "storage_key": "property/5684048244506624/019f150a-be15-7184-86d5-70742d31faa0.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpyoiDWYqTIYRHCB9Bl4_MnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_d733b002-d53a-44e0-8966-b29f656096c2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "American Airlines - Skyview 7",
      "poi_type": "Major Employers & Offices",
      "poi_address": "RWFJ+R6, Transformation Way, Fort Worth, TX 76155, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-f786-705e-afac-3c49ee11df00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-f786-705e-afac-3c49ee11df00",
        "storage_key": "property/5684048244506624/019f150d-f786-705e-afac-3c49ee11df00.webp",
        "width": 1280,
        "height": 450
      },
      "poi_business_url": "http://www.aa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15492633573707074314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "american-airlines---skyview-7",
      "poi_latitude": "32.8291621",
      "poi_longitude": "-97.0659943",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 682-278-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be22-71a7-8bf6-c8a6c16677ff",
        "storage_key": "property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHaLL45iBToYRCssZ3CbkANc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_ba6fd73f-d72c-4996-b61d-4a1a2692cc64",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Texas Health Harris Methodist Hurst-Euless-Bedford",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 Hospital Pkwy, Bedford, TX 76022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-9751-7544-b638-891956542244.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-9751-7544-b638-891956542244",
        "storage_key": "property/5684048244506624/019f150d-9751-7544-b638-891956542244.webp",
        "width": 1279,
        "height": 719
      },
      "poi_business_url": "https://www.texashealth.org/locations/texas-health-heb",
      "poi_directions_map_url": "https://maps.google.com/?cid=8046041147271700356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-health-harris-methodist-hurst-euless-bedford",
      "poi_latitude": "32.8349711",
      "poi_longitude": "-97.1244698",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 817-848-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bdc1-76c7-8a75-f432aaa5bd0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bdc1-76c7-8a75-f432aaa5bd0e",
        "storage_key": "property/5684048244506624/019f150a-bdc1-76c7-8a75-f432aaa5bd0e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJw-xkb7J_ToYRhF9OL8tHqW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_e7324fb5-cd62-41d7-8015-bb6819b57f16",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "United States Air Force Plant 4",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Lockheed Blvd, Fort Worth, TX 76108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://cumulis.epa.gov/supercpad/cursites/csitinfo.cfm?id=0603610",
      "poi_directions_map_url": "https://maps.google.com/?cid=16010628610778343053&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "united-states-air-force-plant-4",
      "poi_latitude": "32.7711827",
      "poi_longitude": "-97.4502721",
      "poi_miles_from_property": "26.1",
      "poi_walking_minutes": "9 hours 41 mins",
      "poi_biking_minutes": "2 hours 31 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be22-71a7-8bf6-c8a6c16677ff",
        "storage_key": "property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbSVNmIQLToYRjSYmwOQtMd4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_61ee9953-2c9b-4b39-8f0e-cfd3e0991f40",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Amazon FTW6",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2601 W Bethel Rd, Grapevine, TX 76051, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150e-053b-71bb-bcd6-c8bcb9dd6ac2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-053b-71bb-bcd6-c8bcb9dd6ac2",
        "storage_key": "property/5684048244506624/019f150e-053b-71bb-bcd6-c8bcb9dd6ac2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://amazon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16815079154549895717&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amazon-ftw6",
      "poi_latitude": "32.95182339999999",
      "poi_longitude": "-97.0305419",
      "poi_miles_from_property": "12.5",
      "poi_walking_minutes": "4 hours 41 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 206-681-7097",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-be22-71a7-8bf6-c8a6c16677ff",
        "storage_key": "property/5684048244506624/019f150a-be22-71a7-8bf6-c8a6c16677ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn2wcBAErTIYRJbIFpWYpW-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_e88400eb-ac33-47aa-8868-dd3747745fd4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Baylor Scott & White Medical Center - Grapevine",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1650 W College St, Grapevine, TX 76051, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-fc14-724c-a4c6-3dfcd956a58f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150d-fc14-724c-a4c6-3dfcd956a58f",
        "storage_key": "property/5684048244506624/019f150d-fc14-724c-a4c6-3dfcd956a58f.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.bswhealth.com/locations/hospital/grapevine?utm_content=main-website&utm_source=pg-google&utm_medium=organic&utm_campaign=29985-7927435",
      "poi_directions_map_url": "https://maps.google.com/?cid=10745585466151126275&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baylor-scott--white-medical-center---grapevine",
      "poi_latitude": "32.9341727",
      "poi_longitude": "-97.0935352",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 817-481-1588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bdc1-76c7-8a75-f432aaa5bd0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bdc1-76c7-8a75-f432aaa5bd0e",
        "storage_key": "property/5684048244506624/019f150a-bdc1-76c7-8a75-f432aaa5bd0e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1a5P6tLUTYYRA8WJhQz9H5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_f233de2b-4b0e-4324-9290-1f2e25641d4e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Tarrant County College - Northeast Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "828 W Harwood Rd, Hurst, TX 76054, USA",
      "poi_short_description": "On-campus shop selling college books, apparel, school supplies, computers, software & electronics.",
      "poi_long_description": "On-campus shop selling college books, apparel, school supplies, computers, software & electronics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-2687-72fe-857d-9d241f0b752a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150a-2687-72fe-857d-9d241f0b752a",
        "storage_key": "property/5684048244506624/019f150a-2687-72fe-857d-9d241f0b752a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tccd.edu/locations/northeast-campus/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6601226914742018412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tarrant-county-college---northeast-campus",
      "poi_latitude": "32.84692560000001",
      "poi_longitude": "-97.1917037",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 817-515-8223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bdc3-714a-a0d2-a15c5987a962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bdc3-714a-a0d2-a15c5987a962",
        "storage_key": "property/5684048244506624/019f150a-bdc3-714a-a0d2-a15c5987a962.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV-TYe8h4ToYRbCHydudEnFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b43b14ca-b9c1-489e-9ef7-8c95a895ac09",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "HEB ISD Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1849 Central Dr, Bedford, TX 76022, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150e-01ad-722a-bac7-1b93f867ddfd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-01ad-722a-bac7-1b93f867ddfd",
        "storage_key": "property/5684048244506624/019f150e-01ad-722a-bac7-1b93f867ddfd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.hebisd.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11828638531553007483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heb-isd-administration-building",
      "poi_latitude": "32.8352588",
      "poi_longitude": "-97.1342016",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 817-283-4461",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bdc3-714a-a0d2-a15c5987a962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bdc3-714a-a0d2-a15c5987a962",
        "storage_key": "property/5684048244506624/019f150a-bdc3-714a-a0d2-a15c5987a962.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ6coE6p_ToYRexe32RLEJ6Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b067fd03-9ac2-49a8-9df6-7eeb6908ec1d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Euless City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "203 N Ector Dr, Euless, TX 76039, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150e-0b55-73bf-90f0-ef08a0c6b023.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-0b55-73bf-90f0-ef08a0c6b023",
        "storage_key": "property/5684048244506624/019f150e-0b55-73bf-90f0-ef08a0c6b023.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.eulesstx.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15218268030446988695&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "euless-city-hall",
      "poi_latitude": "32.8395511",
      "poi_longitude": "-97.0923899",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 817-685-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-c06b-77de-b36a-308803d0af67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-c06b-77de-b36a-308803d0af67",
        "storage_key": "property/5684048244506624/019f150a-c06b-77de-b36a-308803d0af67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu0yrpXiAToYRl-150yQmMtM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_78f83b50-d68a-4ce9-bb2d-3e56e4840e98",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Naval Air Station Joint Reserve Base Fort Worth",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Coody Dr, Westworth Village, TX 76114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150e-06aa-71ea-8e3b-3e5272b84098.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f150e-06aa-71ea-8e3b-3e5272b84098",
        "storage_key": "property/5684048244506624/019f150e-06aa-71ea-8e3b-3e5272b84098.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cnic.navy.mil/fortworth/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15538734546637660030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "naval-air-station-joint-reserve-base-fort-worth",
      "poi_latitude": "32.765145",
      "poi_longitude": "-97.4211979",
      "poi_miles_from_property": "21",
      "poi_walking_minutes": "7 hours 48 mins",
      "poi_biking_minutes": "2 hours 18 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-c06b-77de-b36a-308803d0af67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-c06b-77de-b36a-308803d0af67",
        "storage_key": "property/5684048244506624/019f150a-c06b-77de-b36a-308803d0af67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBfDGQy1zToYRfp9tD76spNc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_45f718a8-40d6-4950-8d6a-9420b7267f53",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "poi_name": "Harmony School of Innovation Euless",
      "poi_type": "Education",
      "poi_address": "701 S Industrial Blvd #105, Euless, TX 76040, USA",
      "poi_short_description": "Harmony Public Schools is a tuition-free network of public charter schools across Texas. We help students build the skills, confidence, and character to succeed in school and in life — with a strong focus on STEM.",
      "poi_long_description": "Harmony School of Innovation - Euless is a K - 5th public charter school providing a high-quality education option for students in the surrounding areas. Our school is a part of the state-wide Harmony Public Schools system. Harmony Public Schools is a system of 58 Texas public charter schools that provides rigorous, high-quality education focused on Our Mission Harmony prepares each student for higher education by providing a safe, caring and collaborative atmosphere. Our curriculum features a quality, student-centered educational program with a strong emphasis on Science, Technology, Engineering and Mathematics. Our Vision Harmony’s vision is to lead our students from the classroom into the world as productive and responsible citizens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f8c53-5f8c-75dc-92e6-5ecd1eb47df9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f8c53-5f8c-75dc-92e6-5ecd1eb47df9",
        "storage_key": "property/5684048244506624/019f8c53-5f8c-75dc-92e6-5ecd1eb47df9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://hsieuless.harmonytx.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8506195479172923592&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "harmony-school-of-innovation-euless",
      "poi_latitude": "32.8276032",
      "poi_longitude": "-97.097716",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 817-554-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150a-bdc3-714a-a0d2-a15c5987a962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f150a-bdc3-714a-a0d2-a15c5987a962",
        "storage_key": "property/5684048244506624/019f150a-bdc3-714a-a0d2-a15c5987a962.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWxOt-yt-ToYRyMAidrgTDHY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    }
  ],
  "office_hours": [
    {
      "id": "custom_f4ad1db7-5aef-4b55-b23f-433f08dc9ee2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_da990cb5-1ef9-4f4a-a3fe-f431ebc3bc6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_59c5c269-9fb7-4131-9bf4-56b876ec67a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_f8c5bfae-e8a0-4911-83a1-b76e97ae56eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_95c01285-55fb-43f4-8582-fe610b6fb972",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_17c42b12-a19b-4d84-9421-2c610738999c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_5f7305b64b6624195afbb276",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "rating": "5",
      "name": "Cynthia Lewis",
      "text": "I Love everything about this Place! it’s beautiful and always clean.The apartments are a nice size. They are modern and up to date!\nNice and quiet. The Staff is great,  especially Ms Yevette 😊 I love the amenities. The Maintenance team I love how fast they respond to your request.And don’t let me get started on our common Area and cafe lounge such a beautiful place to sit and read a book, do so work, or just chill like a home away from home without the beds lol. I could go on and on but I think you catch the vision!",
      "date": "2026-05-20",
      "title": "false"
    },
    {
      "id": "ec_c02ce651f7aa475f368e3bbd",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "rating": "5",
      "name": "Ina Duvernay",
      "text": "Domain at Founders Parc was truly a great decision to live. It is extremely quiet, and clean. I want to give a special shout out to Ivette Fonseca she was my leasing agent very professional, friendly, and informative she has the best personality. All the staff there is amazing. They make you feel like family. Thanks to all of you at Domain at Founders Parc much love and appreciation. I will recommend this complex to anyone and give you all 5 stars plus more. Blessings forever Ina",
      "date": "2026-01-22",
      "title": "false"
    },
    {
      "id": "ec_6b8c473f4bfd7a4987b1c3b4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "rating": "5",
      "name": "Arnold Lopez",
      "text": "I recently toured with Jilisa, and I can honestly say she made the entire experience exceptional. From the moment I arrived, she was welcoming, professional, and incredibly knowledgeable about the community. She took the time to answer every question thoroughly, never made me feel rushed, and genuinely listened to what I was looking for in a new home.\n\nWhat stood out most was her positive attitude and attention to detail. She highlighted all of the community’s amenities, explained the leasing process clearly, and made the tour feel personalized rather than scripted. It’s rare to come across someone who is both highly professional and genuinely caring, but Jilisa absolutely is.\n\nIf you’re considering this community, I highly recommend requesting a tour with Jilisa. She made a lasting impression and provided one of the best apartment touring experiences I’ve ever had. Thank you for going above and beyond!",
      "date": "2026-06-01",
      "title": "false"
    },
    {
      "id": "ec_fab7fdd8c5acbd88ce17aae4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "rating": "5",
      "name": "Kenneth George",
      "text": "To the Management Team at Domain at Founders Parc,\n\nI am writing to convey our sincere appreciation and profound satisfaction with our experience at your community. From the moment we began our search for a new home in Dallas, Domain at Founders Parc distinguished itself as an exceptional, beautifully maintained gated community.\n\nThe entire leasing and move-in process was nothing short of exemplary. We have interacted with numerous properties since arriving in Dallas, and I can confidently say that your team, particularly Krystal, Danielle, and Yvette, are among the most professional, knowledgeable, and genuinely helpful individuals we've encountered. They patiently guided us through every step, answering our questions with clarity and making us feel truly valued. The discussions regarding specials and promotions with the assistant manager were transparent and informative, ensuring we found the perfect fit for our needs.\n\nConcluding our move with your property manager, Krystal, was equally effortless. Her efficiency and clear communication made what can often be a complex process remarkably smooth and stress-free. The seamless coordination from initial inquiry to final move-in is a testament to your team's dedication and organizational excellence.\n\nBeyond the initial process, the living experience has been outstanding. The amenities offered at Domain at Founders Parc are truly impressive and meticulously maintained, significantly enhancing our quality of life here. Furthermore, the responsiveness of your maintenance team is something to behold. On the rare occasions we've required assistance, they have been incredibly swift, efficient, and courteous, resolving issues with minimal disruption.\n\nWe wholeheartedly recommend Domain at Founders Parc to anyone seeking a new residence or considering a visit to this outstanding community. Our experience has been nothing short of exceptional, and we are confident that others will find the same level of satisfaction.\n\nThank you to everyone for creating such a wonderful living environment and for your unwavering commitment to resident satisfaction.\n\nSincerely,\n\nKenneth George",
      "date": "2026-01-14",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_8a444f9e07edbe417572acda",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f14c4-43f0-762d-8e3e-e9fc76b3f629.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-43f0-762d-8e3e-e9fc76b3f629",
        "storage_key": "property/5684048244506624/019f14c4-43f0-762d-8e3e-e9fc76b3f629.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Domain at Founders Parc",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/eN9pG1gHCpQ"
    }
  ],
  "faqs": [
    {
      "id": "custom_347351a2-747f-4559-a27c-2dd92ffd94e7",
      "question": "Is Domain at Founders Parc pet-friendly?",
      "answer": "Yes. Domain at Founders Parc welcomes cats and dogs, up to 2 pets per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For the full pet policy, call the leasing team at (817) 898-5072 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_d87b2060-1b10-414c-8a6d-d1b4877b3e32",
      "question": "How can I schedule a tour at Domain at Founders Parc?",
      "answer": "You can schedule a tour of Domain at Founders Parc online through our Schedule a Tour page, or call the leasing office at (817) 898-5072. You can also view our virtual tours to see the community before visiting in person.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_f852303b-7e38-4a83-b818-bfd3038881e0",
      "question": "What are the leasing office hours at Domain at Founders Parc?",
      "answer": "The Domain at Founders Parc leasing office is open during these hours:\n\n• Monday: 9:00 AM to 6:00 PM\n• Tuesday: 9:00 AM to 6:00 PM\n• Wednesday: 9:00 AM to 6:00 PM\n• Thursday: 9:00 AM to 6:00 PM\n• Friday: 9:00 AM to 6:00 PM\n• Saturday: 10:00 AM to 5:00 PM\n\nHours may change around holidays. Call (817) 898-5072 or visit our contact page to confirm before you visit.",
      "category": "Office Hours",
      "source": "custom"
    },
    {
      "id": "custom_d6a44bb9-de68-4db0-8cbc-0d389a761be5",
      "question": "What floor plans are available at Domain at Founders Parc?",
      "answer": "Domain at Founders Parc offers 1- to 3-bedroom apartment homes ranging from approximately 673 to 1,458 square feet, across 13 floor plans. View layouts, square footage, and current availability on our Floor Plans page, or schedule a tour to see them in person.",
      "category": "Floor Plans & Units",
      "source": "custom"
    },
    {
      "id": "custom_90de56ed-1fca-4106-b2b2-ce6f7f43301e",
      "question": "What amenities does Domain at Founders Parc have?",
      "answer": "Domain at Founders Parc offers a range of community and in-home amenities. Community amenities include: American Landmark 360, Dog Park, Fire Pit, Fitness Center, Online Resident Services, Pool, Select Homes, Lounge, Wine Rack, Conference Room, and Cyber Cafe. In-home features include: cabinets, counters, digital thermostats, garden tub, hard floors, kitchen appliances, kitchen islands, tile backsplash, w&d included, and walk-in closet. See the complete list on our Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_b8cb6b04-e9d3-41ed-9511-17b194980e2e",
      "question": "Where is Domain at Founders Parc located?",
      "answer": "Domain at Founders Parc is located at 880 W Euless Blvd, Euless TX 76040. Nearby you'll find dining at Tassili Mediterranean Buffet & Grill, shopping at Kroger, and green space at West Park. Explore more on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_ebf78ca7-313d-4344-a618-561d165c605c",
      "question": "How do I apply to live at Domain at Founders Parc?",
      "answer": "You can apply to live at Domain at Founders Parc online through our Apply Now page, which walks you through each step. If you have questions, the leasing team can help. Call (817) 898-5072 or reach out through our contact page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_688e537c-4b10-4664-8d90-7c5295033dd7",
      "question": "What do I need to apply at Domain at Founders Parc?",
      "answer": "Applicants should be ready to provide standard rental application information, including government-issued identification, proof of income, and rental history. Qualification requirements can vary, so we recommend confirming the current criteria with the Domain at Founders Parc leasing team at (817) 898-5072 or on our contact page. When you're ready, start on the Apply Now page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_11fe2d2d-3d14-422d-bb1c-b935d9c4e7c2",
      "question": "What is the Landmark 360 program at Domain at Founders Parc?",
      "answer": "Domain at Founders Parc participates in American Landmark's Landmark 360 resident program, which includes three resident promises:\n\n• Move-In Satisfaction Promise: if you are not satisfied within your first 15 days, American Landmark will refund your deposit and waive lease-termination fees.\n• 48-Hour Maintenance Completion Promise: work orders are completed within 48 hours (Monday through Friday), with rent credits if that timeline is missed.\n• Relocation Promise: after six months on your lease, you can transfer to another American Landmark community without penalties, with 60 days' written notice.\nTo learn more, contact the leasing team at (817) 898-5072 or visit our contact page.",
      "category": "Resident Programs",
      "source": "custom"
    },
    {
      "id": "custom_8372bda1-4be0-43a2-9c7a-4a3c264849f8",
      "question": "Does Domain at Founders Parc have a pool?",
      "answer": "Yes. Domain at Founders Parc has a swimming pool for residents. See it alongside our other community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_7b3334d7-dd96-47fb-846a-bfad0a0fdbc2",
      "question": "Does Domain at Founders Parc have a fitness center?",
      "answer": "Yes. Domain at Founders Parc has a fitness center for residents. See all amenities on the Amenities page, or schedule a tour to view it in person.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_98ea6f45-534e-46d3-916f-63d7fbec7c2d",
      "question": "Does Domain at Founders Parc have a dog park?",
      "answer": "Yes. Domain at Founders Parc has an on-site dog park for residents and their dogs. See more community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_394ccd73-4019-40c5-b220-b4a432b3642c",
      "question": "Does Domain at Founders Parc offer virtual tours?",
      "answer": "Yes. Domain at Founders Parc offers virtual tours of Domain at Founders Parc. Start on our Virtual Tours page, then schedule an in-person tour when you are ready.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_2b8caa20-7f1a-41a0-b9be-24dd6f6053ee",
      "question": "What do residents say about living at Domain at Founders Parc?",
      "answer": "Residents frequently mention the helpful staff and responsive maintenance at Domain at Founders Parc. One resident wrote: *\"I Love everything about this Place! it’s beautiful and always clean.The apartments are a nice size. They are modern and up to date! Nice and quiet. The Staff is great, especially Ms Yevette 😊 I love the amenities.\"* Read more resident reviews on our Reviews page.",
      "category": "Resident Life",
      "source": "custom"
    },
    {
      "id": "custom_353fc07e-f707-499d-8492-b05774ba0f07",
      "question": "When was Domain at Founders Parc built?",
      "answer": "Domain at Founders Parc was built in 2020. Schedule a tour to see the finishes in person.",
      "category": "Property History & Features",
      "source": "custom"
    },
    {
      "id": "custom_e3803a6f-3b1f-4e1a-923e-91ae4cb02f0d",
      "question": "What is the pet fee at Domain at Founders Parc?",
      "answer": "Pets at Domain at Founders Parc: cats and dogs are welcome, up to 2 per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For details, contact the leasing team at (817) 898-5072 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_d437e989-c143-4f37-9529-ad9dbc463f8b",
      "question": "What features are included in the apartments at Domain at Founders Parc?",
      "answer": "Apartment homes at Domain at Founders Parc include cabinets, counters, digital thermostats, garden tub, hard floors, kitchen appliances, kitchen islands, tile backsplash, w&d included, and walk-in closet. Browse layouts on our Floor Plans page or schedule a tour.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_a696e998-dbd3-40e8-a8e7-abf955b8097e",
      "question": "What restaurants and shops are near Domain at Founders Parc?",
      "answer": "Nearby restaurants and shops include Tassili Mediterranean Buffet & Grill, Yaksa Restaurant and Bar, Raising Cane's Chicken Fingers, and Fuzzy's Taco Shop. See the full neighborhood guide on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-6904-749c-afbc-405f97b55945",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "domain-at-founders-parc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624"
    },
    {
      "lead_collector_id": "0198aa45-6967-7000-b37d-3886be4fc7dc",
      "lead_source": "FACEBOOK_ADS",
      "name": "domain-at-founders-parc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624"
    },
    {
      "lead_collector_id": "0198aa45-69ca-77db-b7ba-ae591b7fcd85",
      "lead_source": "LANDING_PAGE",
      "name": "domain-at-founders-parc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-for-rent-euless-tx",
      "search_query": "One Bedroom Apartments For Rent In Euless TX",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments For Rent In Euless TX",
      "h2_subtitle": "Discover luxury living at Domain at Founders Parc. Our one bedroom apartments feature modern amenities and a prime location near Grapevine.",
      "page_copy": "Say hello to the good life at Domain at Founders Parc. Our one bedroom apartments for rent in Euless TX feature sophisticated interiors and unmatched in-home features. Enjoy stainless-steel appliances, contemporary cabinets, and wood-style flooring. Each apartment includes a patio or balcony, large closets, and extra storage. Ideally located near Grapevine, our community offers convenient access to the best shops, restaurants, and entertainment in the DFW area. Pet-friendly and recently renovated, Domain at Founders Parc is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and modern apartment buildings in the background.",
        "public_id": "019f6c0e-4bde-72cd-8287-fdc5e0e00708",
        "storage_key": "property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
        "width": 1920,
        "height": 1277
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-54c9-7545-92bb-ecfbe9132d2b",
        "storage_key": "property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Domain at Founders Parc | One Bedroom Apartments For Rent In Euless TX",
      "seo_description": "Discover luxury one bedroom apartments for rent in Euless TX at Domain at Founders Parc. Enjoy modern amenities and a prime location near Grapevine.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "page_item_url": "two-bedrooms-apartments-for-rent-in-euless-tx",
      "search_query": "Two Bedrooms Apartments For Rent In Euless TX",
      "category": "Floorplan",
      "h1_title": "Two Bedrooms Apartments For Rent In Euless TX",
      "h2_subtitle": "Experience luxury living at Domain at Founders Parc. Our two bedroom apartments feature modern amenities and a prime location near Grapevine.",
      "page_copy": "Say hello to the good life at Domain at Founders Parc. Our two bedrooms apartments for rent in Euless TX feature sophisticated interiors and unmatched in-home features. Enjoy stainless-steel appliances, contemporary cabinets, and wood-style flooring. Each apartment includes a patio or balcony, large closets, and extra storage. Ideally located near Grapevine, our community offers convenient access to the best shops, restaurants, and entertainment in the DFW area. Pet-friendly and recently renovated, Domain at Founders Parc is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and modern apartment buildings in the background.",
        "public_id": "019f6c0e-4bde-72cd-8287-fdc5e0e00708",
        "storage_key": "property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
        "width": 1920,
        "height": 1277
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-54c9-7545-92bb-ecfbe9132d2b",
        "storage_key": "property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Domain at Founders Parc | Two Bedrooms Apartments For Rent In Euless TX",
      "seo_description": "Discover luxury two bedrooms apartments for rent in Euless TX at Domain at Founders Parc. Enjoy modern amenities and a prime location near Grapevine.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "page_item_url": "three-bedrooms-apartments-for-rent-in-euless-tx",
      "search_query": "Three Bedrooms Apartments For Rent In Euless TX",
      "category": "Floorplan",
      "h1_title": "Three Bedrooms Apartments For Rent In Euless TX",
      "h2_subtitle": "Embrace luxury living at Domain at Founders Parc. Our three bedroom apartments feature modern amenities and a prime location near Grapevine.",
      "page_copy": "Say hello to the good life at Domain at Founders Parc. Our three bedrooms apartments for rent in Euless TX feature sophisticated interiors and unmatched in-home features. Enjoy stainless-steel appliances, contemporary cabinets, and wood-style flooring. Each apartment includes a patio or balcony, large closets, and extra storage. Ideally located near Grapevine, our community offers convenient access to the best shops, restaurants, and entertainment in the DFW area. Pet-friendly and recently renovated, Domain at Founders Parc is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and modern apartment buildings in the background.",
        "public_id": "019f6c0e-4bde-72cd-8287-fdc5e0e00708",
        "storage_key": "property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
        "width": 1920,
        "height": 1277
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-54c9-7545-92bb-ecfbe9132d2b",
        "storage_key": "property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Domain at Founders Parc | Three Bedrooms Apartments For Rent In Euless TX",
      "seo_description": "Discover luxury three bedrooms apartments for rent in Euless TX at Domain at Founders Parc. Enjoy modern amenities and a prime location near Grapevine.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-resort-inspired-pool-cabanas",
      "search_query": "Apartments For Rent Near Me with Resort-Inspired Pool w/ Cabanas & Water Feature",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Resort-Inspired Pool w/ Cabanas & Water Feature",
      "h2_subtitle": "Experience luxury living at Domain at Founders Parc. Our community features a resort-inspired pool with cabanas and a water feature, perfect for relaxation.",
      "page_copy": "Say hello to the good life at Domain at Founders Parc. Our apartments for rent near me with resort-inspired pool w/ cabanas & water feature offer sophisticated interiors and unmatched in-home features. Enjoy a fully equipped fitness studio, cyber lounge, and resident dog park. Each apartment includes modern amenities like stainless-steel appliances and wood-style flooring. Ideally located near Grapevine, our community provides convenient access to the best shops, restaurants, and entertainment in the DFW area. Pet-friendly and recently renovated, Domain at Founders Parc is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and modern apartment buildings in the background.",
        "public_id": "019f6c0e-4bde-72cd-8287-fdc5e0e00708",
        "storage_key": "property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
        "width": 1920,
        "height": 1277
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-54c9-7545-92bb-ecfbe9132d2b",
        "storage_key": "property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Domain at Founders Parc | Apartments For Rent Near Me with Resort-Inspired Pool w/ Cabanas & Water Feature",
      "seo_description": "Discover luxury apartments for rent near me with resort-inspired pool w/ cabanas & water feature at Domain at Founders Parc. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-fitness-yoga-spin",
      "search_query": "Apartments For Rent Near Me with Fully Equipped Fitness Studio w/ Yoga & Spin Room",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Fully Equipped Fitness Studio w/ Yoga & Spin Room",
      "h2_subtitle": "Discover luxury living at Domain at Founders Parc. Our community features a fully equipped fitness studio with a yoga and spin room, perfect for your fitness needs.",
      "page_copy": "Say hello to the good life at Domain at Founders Parc. Our apartments for rent near me with fully equipped fitness studio w/ yoga & spin room offer sophisticated interiors and unmatched in-home features. Enjoy a resort-inspired pool, cyber lounge, and resident dog park. Each apartment includes modern amenities like stainless-steel appliances and wood-style flooring. Ideally located near Grapevine, our community provides convenient access to the best shops, restaurants, and entertainment in the DFW area. Pet-friendly and recently renovated, Domain at Founders Parc is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and modern apartment buildings in the background.",
        "public_id": "019f6c0e-4bde-72cd-8287-fdc5e0e00708",
        "storage_key": "property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
        "width": 1920,
        "height": 1277
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-54c9-7545-92bb-ecfbe9132d2b",
        "storage_key": "property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Domain at Founders Parc | Apartments For Rent Near Me with Fully Equipped Fitness Studio w/ Yoga & Spin Room",
      "seo_description": "Discover luxury apartments for rent near me with fully equipped fitness studio w/ yoga & spin room at Domain at Founders Parc. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-cyber-lounge-coffee-bar",
      "search_query": "Apartments For Rent Near Me with Cyber Lounge & Coffee Bar",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Cyber Lounge & Coffee Bar",
      "h2_subtitle": "Experience luxury living at Domain at Founders Parc. Our community features a cyber lounge and coffee bar, perfect for work and relaxation.",
      "page_copy": "Say hello to the good life at Domain at Founders Parc. Our apartments for rent near me with cyber lounge & coffee bar offer sophisticated interiors and unmatched in-home features. Enjoy a resort-inspired pool, fully equipped fitness studio, and resident dog park. Each apartment includes modern amenities like stainless-steel appliances and wood-style flooring. Ideally located near Grapevine, our community provides convenient access to the best shops, restaurants, and entertainment in the DFW area. Pet-friendly and recently renovated, Domain at Founders Parc is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and modern apartment buildings in the background.",
        "public_id": "019f6c0e-4bde-72cd-8287-fdc5e0e00708",
        "storage_key": "property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
        "width": 1920,
        "height": 1277
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-54c9-7545-92bb-ecfbe9132d2b",
        "storage_key": "property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Domain at Founders Parc | Apartments For Rent Near Me with Cyber Lounge & Coffee Bar",
      "seo_description": "Discover luxury apartments for rent near me with cyber lounge & coffee bar at Domain at Founders Parc. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-resident-lounge",
      "search_query": "Apartments For Rent Near Me with Resident Lounge",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Resident Lounge",
      "h2_subtitle": "Discover luxury living at Domain at Founders Parc. Our community features a resident lounge, perfect for socializing and relaxation.",
      "page_copy": "Say hello to the good life at Domain at Founders Parc. Our apartments for rent near me with resident lounge offer sophisticated interiors and unmatched in-home features. Enjoy a resort-inspired pool, fully equipped fitness studio, and cyber lounge. Each apartment includes modern amenities like stainless-steel appliances and wood-style flooring. Ideally located near Grapevine, our community provides convenient access to the best shops, restaurants, and entertainment in the DFW area. Pet-friendly and recently renovated, Domain at Founders Parc is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and modern apartment buildings in the background.",
        "public_id": "019f6c0e-4bde-72cd-8287-fdc5e0e00708",
        "storage_key": "property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
        "width": 1920,
        "height": 1277
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-54c9-7545-92bb-ecfbe9132d2b",
        "storage_key": "property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Domain at Founders Parc | Apartments For Rent Near Me with Resident Lounge",
      "seo_description": "Discover luxury apartments for rent near me with resident lounge at Domain at Founders Parc. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-fire-pit-outdoor-kitchen",
      "search_query": "Apartments For Rent Near Me with Fire Pit & Outdoor Kitchen",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Fire Pit & Outdoor Kitchen",
      "h2_subtitle": "Experience luxury living at Domain at Founders Parc. Our community features a fire pit and outdoor kitchen, perfect for entertaining and relaxation.",
      "page_copy": "Say hello to the good life at Domain at Founders Parc. Our apartments for rent near me with fire pit & outdoor kitchen offer sophisticated interiors and unmatched in-home features. Enjoy a resort-inspired pool, fully equipped fitness studio, and cyber lounge. Each apartment includes modern amenities like stainless-steel appliances and wood-style flooring. Ideally located near Grapevine, our community provides convenient access to the best shops, restaurants, and entertainment in the DFW area. Pet-friendly and recently renovated, Domain at Founders Parc is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and modern apartment buildings in the background.",
        "public_id": "019f6c0e-4bde-72cd-8287-fdc5e0e00708",
        "storage_key": "property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
        "width": 1920,
        "height": 1277
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-54c9-7545-92bb-ecfbe9132d2b",
        "storage_key": "property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Domain at Founders Parc | Apartments For Rent Near Me with Fire Pit & Outdoor Kitchen",
      "seo_description": "Discover luxury apartments for rent near me with fire pit & outdoor kitchen at Domain at Founders Parc. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-large-closets",
      "search_query": "Apartments For Rent Near Me with Large Closets",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Large Closets",
      "h2_subtitle": "Discover luxury living at Domain at Founders Parc. Our community features apartments with large closets, perfect for all your storage needs.",
      "page_copy": "Say hello to the good life at Domain at Founders Parc. Our apartments for rent near me with large closets offer sophisticated interiors and unmatched in-home features. Enjoy contemporary cabinets, stainless-steel appliances, and wood-style flooring. Each apartment includes modern amenities like garden-style soaking tubs, walk-in showers, and dual vanities. Ideally located near Grapevine, our community provides convenient access to the best shops, restaurants, and entertainment in the DFW area. Pet-friendly and recently renovated, Domain at Founders Parc is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and modern apartment buildings in the background.",
        "public_id": "019f6c0e-4bde-72cd-8287-fdc5e0e00708",
        "storage_key": "property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
        "width": 1920,
        "height": 1277
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-54c9-7545-92bb-ecfbe9132d2b",
        "storage_key": "property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Domain at Founders Parc | Apartments For Rent Near Me with Large Closets",
      "seo_description": "Discover luxury apartments for rent near me with large closets at Domain at Founders Parc. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-extra-storage",
      "search_query": "Apartments For Rent Near Me with Extra Storage",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Extra Storage",
      "h2_subtitle": "Experience luxury living at Domain at Founders Parc. Our community features apartments with extra storage, perfect for all your belongings.",
      "page_copy": "Say hello to the good life at Domain at Founders Parc. Our apartments for rent near me with extra storage offer sophisticated interiors and unmatched in-home features. Enjoy contemporary cabinets, stainless-steel appliances, and wood-style flooring. Each apartment includes modern amenities like garden-style soaking tubs, walk-in showers, and dual vanities. Ideally located near Grapevine, our community provides convenient access to the best shops, restaurants, and entertainment in the DFW area. Pet-friendly and recently renovated, Domain at Founders Parc is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and modern apartment buildings in the background.",
        "public_id": "019f6c0e-4bde-72cd-8287-fdc5e0e00708",
        "storage_key": "property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
        "width": 1920,
        "height": 1277
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-54c9-7545-92bb-ecfbe9132d2b",
        "storage_key": "property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Domain at Founders Parc | Apartments For Rent Near Me with Extra Storage",
      "seo_description": "Discover luxury apartments for rent near me with extra storage at Domain at Founders Parc. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-kitchen-islands",
      "search_query": "Apartments For Rent Near Me with Kitchen Islands*",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Kitchen Islands*",
      "h2_subtitle": "Discover luxury living at Domain at Founders Parc. Our community features apartments with kitchen islands*, perfect for your culinary adventures.",
      "page_copy": "Say hello to the good life at Domain at Founders Parc. Our apartments for rent near me with kitchen islands* offer sophisticated interiors and unmatched in-home features. Enjoy contemporary cabinets, stainless-steel appliances, and wood-style flooring. Each apartment includes modern amenities like garden-style soaking tubs, walk-in showers, and dual vanities. Ideally located near Grapevine, our community provides convenient access to the best shops, restaurants, and entertainment in the DFW area. Pet-friendly and recently renovated, Domain at Founders Parc is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and modern apartment buildings in the background.",
        "public_id": "019f6c0e-4bde-72cd-8287-fdc5e0e00708",
        "storage_key": "property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
        "width": 1920,
        "height": 1277
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-54c9-7545-92bb-ecfbe9132d2b",
        "storage_key": "property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Domain at Founders Parc | Apartments For Rent Near Me with Kitchen Islands*",
      "seo_description": "Discover luxury apartments for rent near me with kitchen islands* at Domain at Founders Parc. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-contemporary-cabinets",
      "search_query": "Apartments For Rent Near Me with Contemporary Cabinets",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Contemporary Cabinets",
      "h2_subtitle": "Experience luxury living at Domain at Founders Parc. Our community features apartments with contemporary cabinets, perfect for modern living.",
      "page_copy": "Say hello to the good life at Domain at Founders Parc. Our apartments for rent near me with contemporary cabinets offer sophisticated interiors and unmatched in-home features. Enjoy stainless-steel appliances, wood-style flooring, and garden-style soaking tubs. Each apartment includes modern amenities like walk-in showers, dual vanities, and large closets. Ideally located near Grapevine, our community provides convenient access to the best shops, restaurants, and entertainment in the DFW area. Pet-friendly and recently renovated, Domain at Founders Parc is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and modern apartment buildings in the background.",
        "public_id": "019f6c0e-4bde-72cd-8287-fdc5e0e00708",
        "storage_key": "property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
        "width": 1920,
        "height": 1277
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-54c9-7545-92bb-ecfbe9132d2b",
        "storage_key": "property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Domain at Founders Parc | Apartments For Rent Near Me with Contemporary Cabinets",
      "seo_description": "Discover luxury apartments for rent near me with contemporary cabinets at Domain at Founders Parc. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-stainless-steel-appliances",
      "search_query": "Apartments For Rent Near Me with Stainless-Steel Appliances",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Stainless-Steel Appliances",
      "h2_subtitle": "Discover luxury living at Domain at Founders Parc. Our community features apartments with stainless-steel appliances, perfect for modern living.",
      "page_copy": "Say hello to the good life at Domain at Founders Parc. Our apartments for rent near me with stainless-steel appliances offer sophisticated interiors and unmatched in-home features. Enjoy contemporary cabinets, wood-style flooring, and garden-style soaking tubs. Each apartment includes modern amenities like walk-in showers, dual vanities, and large closets. Ideally located near Grapevine, our community provides convenient access to the best shops, restaurants, and entertainment in the DFW area. Pet-friendly and recently renovated, Domain at Founders Parc is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and modern apartment buildings in the background.",
        "public_id": "019f6c0e-4bde-72cd-8287-fdc5e0e00708",
        "storage_key": "property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
        "width": 1920,
        "height": 1277
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-54c9-7545-92bb-ecfbe9132d2b",
        "storage_key": "property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Domain at Founders Parc | Apartments For Rent Near Me with Stainless-Steel Appliances",
      "seo_description": "Discover luxury apartments for rent near me with stainless-steel appliances at Domain at Founders Parc. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "page_item_url": "apartments-for-rent-euless-tx-near-texas-health",
      "search_query": "Apartments For Rent In Euless TX Near Texas Health Arlington Memorial Hospital",
      "category": "POI",
      "h1_title": "Apartments For Rent In Euless TX Near Texas Health Arlington Memorial Hospital",
      "h2_subtitle": "Discover luxury living at Domain at Founders Parc. Our community offers convenient access to Texas Health Arlington Memorial Hospital.",
      "page_copy": "Say hello to the good life at Domain at Founders Parc. Our apartments for rent in Euless TX near Texas Health Arlington Memorial Hospital offer sophisticated interiors and unmatched in-home features. Enjoy contemporary cabinets, stainless-steel appliances, and wood-style flooring. Each apartment includes modern amenities like garden-style soaking tubs, walk-in showers, and dual vanities. Ideally located near Grapevine, our community provides convenient access to the best shops, restaurants, and entertainment in the DFW area. Pet-friendly and recently renovated, Domain at Founders Parc is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and modern apartment buildings in the background.",
        "public_id": "019f6c0e-4bde-72cd-8287-fdc5e0e00708",
        "storage_key": "property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
        "width": 1920,
        "height": 1277
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-54c9-7545-92bb-ecfbe9132d2b",
        "storage_key": "property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Domain at Founders Parc | Apartments For Rent In Euless TX Near Texas Health Arlington Memorial Hospital",
      "seo_description": "Discover luxury apartments for rent in Euless TX near Texas Health Arlington Memorial Hospital at Domain at Founders Parc. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "page_item_url": "apartments-for-rent-euless-tx-near-healthcare-associates",
      "search_query": "Apartments For Rent In Euless TX Near Healthcare Associates of Texas - Irving North",
      "category": "POI",
      "h1_title": "Apartments For Rent In Euless TX Near Healthcare Associates of Texas - Irving North",
      "h2_subtitle": "Discover luxury living at Domain at Founders Parc. Our community offers convenient access to Healthcare Associates of Texas - Irving North.",
      "page_copy": "Say hello to the good life at Domain at Founders Parc. Our apartments for rent in Euless TX near Healthcare Associates of Texas - Irving North offer sophisticated interiors and unmatched in-home features. Enjoy contemporary cabinets, stainless-steel appliances, and wood-style flooring. Each apartment includes modern amenities like garden-style soaking tubs, walk-in showers, and dual vanities. Ideally located near Grapevine, our community provides convenient access to the best shops, restaurants, and entertainment in the DFW area. Pet-friendly and recently renovated, Domain at Founders Parc is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and modern apartment buildings in the background.",
        "public_id": "019f6c0e-4bde-72cd-8287-fdc5e0e00708",
        "storage_key": "property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
        "width": 1920,
        "height": 1277
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-54c9-7545-92bb-ecfbe9132d2b",
        "storage_key": "property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Domain at Founders Parc | Apartments For Rent In Euless TX Near Healthcare Associates of Texas - Irving North",
      "seo_description": "Discover luxury apartments for rent in Euless TX near Healthcare Associates of Texas - Irving North at Domain at Founders Parc. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "page_item_url": "apartments-for-rent-euless-tx-near-psycho-neuro-center",
      "search_query": "Apartments For Rent In Euless TX Near Psycho Neuro Plasticity Center",
      "category": "POI",
      "h1_title": "Apartments For Rent In Euless TX Near Psycho Neuro Plasticity Center",
      "h2_subtitle": "Discover luxury living at Domain at Founders Parc. Our community offers convenient access to the Psycho Neuro Plasticity Center.",
      "page_copy": "Say hello to the good life at Domain at Founders Parc. Our apartments for rent in Euless TX near Psycho Neuro Plasticity Center offer sophisticated interiors and unmatched in-home features. Enjoy contemporary cabinets, stainless-steel appliances, and wood-style flooring. Each apartment includes modern amenities like garden-style soaking tubs, walk-in showers, and dual vanities. Ideally located near Grapevine, our community provides convenient access to the best shops, restaurants, and entertainment in the DFW area. Pet-friendly and recently renovated, Domain at Founders Parc is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and modern apartment buildings in the background.",
        "public_id": "019f6c0e-4bde-72cd-8287-fdc5e0e00708",
        "storage_key": "property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
        "width": 1920,
        "height": 1277
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-54c9-7545-92bb-ecfbe9132d2b",
        "storage_key": "property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Domain at Founders Parc | Apartments For Rent In Euless TX Near Psycho Neuro Plasticity Center",
      "seo_description": "Discover luxury apartments for rent in Euless TX near Psycho Neuro Plasticity Center at Domain at Founders Parc. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "page_item_url": "apartments-for-rent-euless-tx-near-dallas-college",
      "search_query": "Apartments For Rent In Euless TX Near Dallas College North Lake Campus",
      "category": "POI",
      "h1_title": "Apartments For Rent In Euless TX Near Dallas College North Lake Campus",
      "h2_subtitle": "Discover luxury living at Domain at Founders Parc. Our community offers convenient access to Dallas College North Lake Campus.",
      "page_copy": "Say hello to the good life at Domain at Founders Parc. Our apartments for rent in Euless TX near Dallas College North Lake Campus offer sophisticated interiors and unmatched in-home features. Enjoy contemporary cabinets, stainless-steel appliances, and wood-style flooring. Each apartment includes modern amenities like garden-style soaking tubs, walk-in showers, and dual vanities. Ideally located near Grapevine, our community provides convenient access to the best shops, restaurants, and entertainment in the DFW area. Pet-friendly and recently renovated, Domain at Founders Parc is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and modern apartment buildings in the background.",
        "public_id": "019f6c0e-4bde-72cd-8287-fdc5e0e00708",
        "storage_key": "property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
        "width": 1920,
        "height": 1277
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-54c9-7545-92bb-ecfbe9132d2b",
        "storage_key": "property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Domain at Founders Parc | Apartments For Rent In Euless TX Near Dallas College North Lake Campus",
      "seo_description": "Discover luxury apartments for rent in Euless TX near Dallas College North Lake Campus at Domain at Founders Parc. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "page_item_url": "apartments-for-rent-euless-tx-near-uti",
      "search_query": "Apartments For Rent In Euless TX Near Universal Technical Institute",
      "category": "POI",
      "h1_title": "Apartments For Rent In Euless TX Near Universal Technical Institute",
      "h2_subtitle": "Discover luxury living at Domain at Founders Parc. Our community offers convenient access to Universal Technical Institute.",
      "page_copy": "Say hello to the good life at Domain at Founders Parc. Our apartments for rent in Euless TX near Universal Technical Institute offer sophisticated interiors and unmatched in-home features. Enjoy contemporary cabinets, stainless-steel appliances, and wood-style flooring. Each apartment includes modern amenities like garden-style soaking tubs, walk-in showers, and dual vanities. Ideally located near Grapevine, our community provides convenient access to the best shops, restaurants, and entertainment in the DFW area. Pet-friendly and recently renovated, Domain at Founders Parc is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and modern apartment buildings in the background.",
        "public_id": "019f6c0e-4bde-72cd-8287-fdc5e0e00708",
        "storage_key": "property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
        "width": 1920,
        "height": 1277
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-54c9-7545-92bb-ecfbe9132d2b",
        "storage_key": "property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Domain at Founders Parc | Apartments For Rent In Euless TX Near Universal Technical Institute",
      "seo_description": "Discover luxury apartments for rent in Euless TX near Universal Technical Institute at Domain at Founders Parc. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "page_item_url": "apartments-for-rent-euless-tx-near-dallas-baptist-univ",
      "search_query": "Apartments For Rent In Euless TX Near Dallas Baptist University",
      "category": "POI",
      "h1_title": "Apartments For Rent In Euless TX Near Dallas Baptist University",
      "h2_subtitle": "Discover luxury living at Domain at Founders Parc. Our community offers convenient access to Dallas Baptist University.",
      "page_copy": "Say hello to the good life at Domain at Founders Parc. Our apartments for rent in Euless TX near Dallas Baptist University offer sophisticated interiors and unmatched in-home features. Enjoy contemporary cabinets, stainless-steel appliances, and wood-style flooring. Each apartment includes modern amenities like garden-style soaking tubs, walk-in showers, and dual vanities. Ideally located near Grapevine, our community provides convenient access to the best shops, restaurants, and entertainment in the DFW area. Pet-friendly and recently renovated, Domain at Founders Parc is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and modern apartment buildings in the background.",
        "public_id": "019f6c0e-4bde-72cd-8287-fdc5e0e00708",
        "storage_key": "property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
        "width": 1920,
        "height": 1277
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-54c9-7545-92bb-ecfbe9132d2b",
        "storage_key": "property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Domain at Founders Parc | Apartments For Rent In Euless TX Near Dallas Baptist University",
      "seo_description": "Discover luxury apartments for rent in Euless TX near Dallas Baptist University at Domain at Founders Parc. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5684048244506624",
      "source": "custom",
      "page_item_url": "apartments-for-rent-euless-tx-near-university-dallas",
      "search_query": "Apartments For Rent In Euless TX Near University of Dallas",
      "category": "POI",
      "h1_title": "Apartments For Rent In Euless TX Near University of Dallas",
      "h2_subtitle": "Discover luxury living at Domain at Founders Parc. Our community offers convenient access to the University of Dallas.",
      "page_copy": "Say hello to the good life at Domain at Founders Parc. Our apartments for rent in Euless TX near University of Dallas offer sophisticated interiors and unmatched in-home features. Enjoy contemporary cabinets, stainless-steel appliances, and wood-style flooring. Each apartment includes modern amenities like garden-style soaking tubs, walk-in showers, and dual vanities. Ideally located near Grapevine, our community provides convenient access to the best shops, restaurants, and entertainment in the DFW area. Pet-friendly and recently renovated, Domain at Founders Parc is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and modern apartment buildings in the background.",
        "public_id": "019f6c0e-4bde-72cd-8287-fdc5e0e00708",
        "storage_key": "property/5684048244506624/019f6c0e-4bde-72cd-8287-fdc5e0e00708.webp",
        "width": 1920,
        "height": 1277
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0e-54c9-7545-92bb-ecfbe9132d2b",
        "storage_key": "property/5684048244506624/019f6c0e-54c9-7545-92bb-ecfbe9132d2b.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Domain at Founders Parc | Apartments For Rent In Euless TX Near University of Dallas",
      "seo_description": "Discover luxury apartments for rent in Euless TX near University of Dallas at Domain at Founders Parc. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2155"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376470913"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a28\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a28\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4792503"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-53BKDCL"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443965266"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "e811e11f163f0eb6"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/l8xvrl96vjk"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/23fee0a8-2efa-4f34-bb0d-2510cf703992"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "817-934-6649"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Im9yd08xRks3VmpteUI3bHFWV3E3Nmc9PSIsInZhbHVlIjoiaHl3WHA0VDUwdHJGZjlmTXdXZjR3dz09IiwibWFjIjoiZWMyYzJiNGE0NjBmYWM5NjgyYWIxMmIwNTAxMWQzNzMzMTA5ZjZhYzAxNzhiODFhYWQxNzlhMzA5ZjI5YjI1MSJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2155",
  "custom_repli_id": "2376470913",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a28\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a28\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4792503",
  "custom_google_gtm_id": "GTM-53BKDCL",
  "custom_rollout_phase": "1",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443965266",
  "custom_knock_community_id": "e811e11f163f0eb6",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/l8xvrl96vjk",
  "custom_self_guided_tour_url": "https://selftournow.com/property/23fee0a8-2efa-4f34-bb0d-2510cf703992",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "817-934-6649",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Im9yd08xRks3VmpteUI3bHFWV3E3Nmc9PSIsInZhbHVlIjoiaHl3WHA0VDUwdHJGZjlmTXdXZjR3dz09IiwibWFjIjoiZWMyYzJiNGE0NjBmYWM5NjgyYWIxMmIwNTAxMWQzNzMzMTA5ZjZhYzAxNzhiODFhYWQxNzlhMzA5ZjI5YjI1MSJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "11eff30a-4b06-437a-a759-a23f1c5bba4d",
  "custom_audioeye_site_hash": "4ea19368cd9f161318dda4577fc2e11b"
};

export const generatedAt = '2026-11-03T20:36:54.081Z';
